import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Form, Modal, Row, Image, Button } from 'react-bootstrap';
import { OutlinedInput, FormControl, IconButton } from '@material-ui/core';
import { ReusableOnboardingButton } from '../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
import { TopTextReusableComponent } from '../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent';
import { ToggleButtonWithYesNo } from '../../../../AllButton/ToggleButtonReuse';
// import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { useFormik } from 'formik';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  update_item_menu_setup,
  get_category_menu_setup_without_loader,
} from '../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import { useHistory } from 'react-router-dom';
import Alert from 'react-s-alert';
import ServicesEditReuse from './ServicesEditReuse';
import TaxesSurCharges, {
  AddSurchargesModel,
  TaxesServices,
} from '../TaxesSurCharges';

const Services = (props) => {
  const history = useHistory();
  const back = () => {
    if (props.menuCategoryItems.itemSize === 'CUSTOM') {
      props.onChange(8);
    } else {
      props.onChange(7);
    }

    window.scroll(0, 0);
  };

  const information = useSelector((state) => {
    return {
      personalization_information:
        state.onboarding.restaurantDetails.personalization_information,
      allergic_information:
        state.onboarding.restaurantDetails.allergic_information,
      nutrition_information:
        state.onboarding.restaurantDetails.nutrition_information,
    };
  });

  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    if (
      props.menuCategoryItems.currentState !== 9 ||
      props.menuCategoryItems.runingTrack !== 9
    ) {
      if (props.menuCategoryItems.itemSize === 'CUSTOM') {
        formData.currentState = 9;
        formData.runingTrack = 8;
      } else {
        if (information.nutrition_information) {
          formData.currentState = 9;
          formData.runingTrack = 7;
        } else {
          formData.currentState = 9;
          formData.runingTrack = 6;
        }
      }
      // if (props.menuCategoryItems.itemSize === "CUSTOM") {
      //   formData.currentState = 7;
      //   formData.runingTrack = 8;
      // } else {
      //   formData.currentState = 6;
      //   formData.runingTrack = 7;
      // }
    }
    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  const [newTaxesSkipLine, setNewTaxesSkipLine] = useState([]);
  const [showSkipTheLine, setShowSkeipTheLine] = useState(false);
  const [showTakeAway, setShowTakeAway] = useState(true);
  const [showCurbSide, setShowCurbSide] = useState(false);
  const [showDineIn, setShowDineIn] = useState(false);
  const [showCateringBanquet, setShowCateringBanquet] = useState(false);
  const [showHomeDelivery, setShowHomeDelivery] = useState(false);

  const [showDetails, setShowDetails] = useState(false);
  const handleShowDetails = (name) => {
    setActiveName(name);
    if (name === 'skip_line') {
      setActiveData(formik.values.skip_line.sizes);
    } else if (name === 'take_away') {
      setActiveData(formik.values.take_away.sizes);
    } else if (name === 'curb_side') {
      setActiveData(formik.values.curb_side.sizes);
    } else if (name === 'dine_in') {
      setActiveData(formik.values.dine_in.sizes);
    } else if (name === 'catering_banquet') {
      setActiveData(formik.values?.catering_banquet?.sizes);
    } else if (name === 'home_delivery') {
      setActiveData(formik.values?.home_delivery?.sizes);
    }
    setShowDetails(true);
  };
  const handleCloseDetails = () => setShowDetails(false);
  const [showDeleteModal, onShowDeleteModal] = useState(false);
  const handleCloseDeleteModal = () => onShowDeleteModal(false);
  const [activeName, setActiveName] = useState('');
  const [activeData, setActiveData] = useState([]);
  // const onClickDeleteSurCharge = (e, id, name) => {
  //   e.preventDefault();
  //   setActiveNameSurcharge(name);
  //   setEditIndex(id);
  //   onShowDeleteModal(true);
  // };
  const handleDeleteModal = (e) => {
    e.preventDefault();

    if (activeNameSurcharge === 'skip_line') {
      let updateDeleted = formik.values.skip_line.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue('skip_line.sur_charges', updateDeleted);
    } else if (activeNameSurcharge === 'take_away') {
      let updateDeleted = formik.values.take_away.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue('take_away.sur_charges', updateDeleted);
    } else if (activeNameSurcharge === 'curb_side') {
      let updateDeleted = formik.values.curb_side.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue('curb_side.sur_charges', updateDeleted);
    } else if (activeNameSurcharge === 'dine_in') {
      let updateDeleted = formik.values.dine_in.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue('dine_in.sur_charges', updateDeleted);
    } else if (activeNameSurcharge === 'catering_banquet') {
      let updateDeleted = formik.values?.catering_banquet?.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue('catering_banquet.sur_charges', updateDeleted);
    } else if (activeNameSurcharge === 'home_delivery') {
      let updateDeleted = formik.values?.home_delivery?.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue('home_delivery.sur_charges', updateDeleted);
    }

    onShowDeleteModal(false);
  };

  const [deleteItem, setDeleteItem] = useState(false);
  const closeDeleteItem = () => setDeleteItem(false);

  const onClickDeleteItem = (e, id, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    setEditIndex(id);
    setDeleteItem(true);
  };

  const handleDeleteItem = (e) => {
    e.preventDefault();

    if (activeNameSurcharge === 'skip_line') {
      let updateDeleted = formik.values.skip_line.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      let foundDefault = true;
      let defaultData = updateDeleted;
      if (defaultData.length > 0) {
        if (defaultData.length !== 0) {
          for (let i = 0; i < updateDeleted.length; i++) {
            if (updateDeleted.isDefault) {
              break;
            } else {
              foundDefault = false;
            }
          }
          if (!foundDefault && defaultData.length > 0) {
            defaultData[0].isDefault = true;
            defaultData[0].available = true;
          }
        }
      } else {
        formik.setFieldValue('skip_line.value', false);
      }
      formik.setFieldValue('skip_line.sizes', defaultData);
      setActiveData(defaultData);
    } else if (activeNameSurcharge === 'take_away') {
      let updateDeleted = formik.values.take_away.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      let foundDefault = true;
      let defaultData = updateDeleted;
      if (defaultData.length > 0) {
        if (defaultData.length !== 0) {
          for (let i = 0; i < updateDeleted.length; i++) {
            if (updateDeleted.isDefault) {
              break;
            } else {
              foundDefault = false;
            }
          }
          if (!foundDefault && defaultData.length > 0) {
            defaultData[0].isDefault = true;
            defaultData[0].available = true;
          }
        }
      } else {
        formik.setFieldValue('take_away.value', false);
      }
      formik.setFieldValue('take_away.sizes', defaultData);
      setActiveData(defaultData);
    } else if (activeNameSurcharge === 'curb_side') {
      let updateDeleted = formik.values.curb_side.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      let foundDefault = true;
      let defaultData = updateDeleted;
      if (defaultData.length > 0) {
        if (defaultData.length !== 0) {
          for (let i = 0; i < updateDeleted.length; i++) {
            if (updateDeleted.isDefault) {
              break;
            } else {
              foundDefault = false;
            }
          }
          if (!foundDefault && defaultData.length > 0) {
            defaultData[0].isDefault = true;
            defaultData[0].available = true;
          }
        }
      } else {
        formik.setFieldValue('curb_side.value', false);
      }
      formik.setFieldValue('curb_side.sizes', defaultData);
      setActiveData(defaultData);
    } else if (activeNameSurcharge === 'dine_in') {
      let updateDeleted = formik.values.dine_in.sizes.filter((item, index) => {
        return index !== editIndex;
      });
      let foundDefault = true;
      let defaultData = updateDeleted;
      if (defaultData.length > 0) {
        if (defaultData.length !== 0) {
          for (let i = 0; i < updateDeleted.length; i++) {
            if (updateDeleted.isDefault) {
              break;
            } else {
              foundDefault = false;
            }
          }
          if (!foundDefault && defaultData.length > 0) {
            defaultData[0].isDefault = true;
            defaultData[0].available = true;
          }
        }
      } else {
        formik.setFieldValue('dine_in.value', false);
      }
      formik.setFieldValue('dine_in.sizes', defaultData);
      setActiveData(defaultData);
    } else if (activeNameSurcharge === 'catering_banquet') {
      let updateDeleted = formik.values?.catering_banquet?.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      let foundDefault = true;
      let defaultData = updateDeleted;
      if (defaultData.length > 0) {
        if (defaultData.length !== 0) {
          for (let i = 0; i < updateDeleted.length; i++) {
            if (updateDeleted.isDefault) {
              break;
            } else {
              foundDefault = false;
            }
          }
          if (!foundDefault && defaultData.length > 0) {
            defaultData[0].isDefault = true;
            defaultData[0].available = true;
          }
        }
      } else {
        formik.setFieldValue('catering_banquet.value', false);
      }
      formik.setFieldValue('catering_banquet.sizes', defaultData);
      setActiveData(defaultData);
    } else if (activeNameSurcharge === 'home_delivery') {
      let updateDeleted = formik.values?.home_delivery?.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      let foundDefault = true;
      let defaultData = updateDeleted;
      if (defaultData.length > 0) {
        if (defaultData.length !== 0) {
          for (let i = 0; i < updateDeleted.length; i++) {
            if (updateDeleted.isDefault) {
              break;
            } else {
              foundDefault = false;
            }
          }
          if (!foundDefault && defaultData.length > 0) {
            defaultData[0].isDefault = true;
            defaultData[0].available = true;
          }
        }
      } else {
        formik.setFieldValue('home_delivery.value', false);
      }
      formik.setFieldValue('home_delivery.sizes', defaultData);
      setActiveData(defaultData);
    }
    closeDeleteItem();
  };

  const [active, setActive] = useState(1);
  const handleTextPORV = (e) => {
    setActive(e);
    formikSurcharge.setFieldValue('flag', e);
  };

  const redirectToStep3 = (e) => {
    props.onChange(6);
  };
  const [editIndex, setEditIndex] = useState();
  const [editStatus, setEditStatus] = useState(false);

  const [activeNameSurcharge, setActiveNameSurcharge] = useState('');
  const [step, setStep] = useState(props.origin ? 5 : 1);
  const handleStepChange = (v) => setStep(v);

  const handleStep1Change = () => {
    if (showTakeAway) {
      handleStepChange(2);
    } else if (showCurbSide) {
      handleStepChange(3);
    } else if (showDineIn) {
      handleStepChange(4);
    } else if (showCateringBanquet) {
      handleStepChange(5);
    } else if (showHomeDelivery) {
      handleStepChange(6);
    } else {
      handleStepChange(7);
    }
  };

  const handleStep2Change = () => {
    if (showCurbSide) {
      handleStepChange(3);
    } else if (showDineIn) {
      handleStepChange(4);
    } else if (showCateringBanquet) {
      handleStepChange(5);
    } else if (showHomeDelivery) {
      handleStepChange(6);
    } else {
      handleStepChange(7);
    }
  };

  const handleStep3Change = () => {
    if (showDineIn) {
      handleStepChange(4);
    } else if (showCateringBanquet) {
      handleStepChange(5);
    } else if (showHomeDelivery) {
      handleStepChange(6);
    } else {
      handleStepChange(7);
    }
  };

  const handleStep4Change = () => {
    if (showCateringBanquet) {
      handleStepChange(5);
    } else if (showHomeDelivery) {
      handleStepChange(6);
    } else {
      handleStepChange(7);
    }
  };

  const handleStep5Change = () => {
    if (showHomeDelivery) {
      handleStepChange(6);
    } else {
      handleStepChange(7);
    }
  };

  const handleStep2BackButton = () => {
    if (showSkipTheLine) {
      handleStepChange(1);
    } else {
      onClickBack();
    }
  };

  const handleStep3BackButton = () => {
    if (showTakeAway) {
      handleStepChange(2);
    } else {
      handleStepChange(1);
    }
  };

  const handleStep4BackButton = () => {
    if (showCurbSide) {
      handleStepChange(3);
    } else if (showTakeAway) {
      handleStepChange(2);
    } else {
      handleStepChange(1);
    }
  };

  const handleStep5BackButton = () => {
    if (showDineIn) {
      handleStepChange(4);
    } else if (showCurbSide) {
      handleStepChange(3);
    } else if (showTakeAway) {
      handleStepChange(2);
    } else {
      handleStepChange(1);
    }
  };

  const handleStep6BackButton = () => {
    if (showCateringBanquet) {
      handleStepChange(5);
    } else if (showDineIn) {
      handleStepChange(4);
    } else if (showCurbSide) {
      handleStepChange(3);
    } else if (showTakeAway) {
      handleStepChange(2);
    } else {
      handleStepChange(1);
    }
  };

  const handleStep7BackButton = () => {
    if (showHomeDelivery) {
      handleStepChange(6);
    } else if (showCateringBanquet) {
      handleStepChange(5);
    } else if (showDineIn) {
      handleStepChange(4);
    } else if (showCurbSide) {
      handleStepChange(3);
    } else if (showTakeAway) {
      handleStepChange(2);
    } else {
      handleStepChange(1);
    }
  };

  // skip line start

  const [skipLineSurcharge, setSkipLineSurCharge] = useState(false);
  const onChangeSkipLine = () => {
    formik.setFieldValue('skip_line.value', !formik.values.skip_line.value);
  };

  const onClickAddSkipLineSurcharge = (e) => {
    e.preventDefault();
    setSkipLineSurCharge(!skipLineSurcharge);
  };

  const onClickSaveSkipLineSurcharge = (e, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    formikSurcharge.handleSubmit();
  };

  const onChangeAvaiblity = (status, id, name) => {
    if (name === 'skip_line') {
      let updateAvailable = formik.values.skip_line.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue('skip_line.sizes', updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === 'take_away') {
      let updateAvailable = formik.values.take_away.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue('take_away.sizes', updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === 'curb_side') {
      let updateAvailable = formik.values.curb_side.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue('curb_side.sizes', updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === 'dine_in') {
      let updateAvailable = formik.values.dine_in.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue('dine_in.sizes', updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === 'catering_banquet') {
      let updateAvailable = formik.values?.catering_banquet?.sizes.map(
        (item, index) => {
          if (index === id) {
            return { ...item, available: !status };
          } else {
            return { ...item };
          }
        }
      );
      formik.setFieldValue('catering_banquet.sizes', updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === 'home_delivery') {
      let updateAvailable = formik.values?.home_delivery?.sizes.map(
        (item, index) => {
          if (index === id) {
            return { ...item, available: !status };
          } else {
            return { ...item };
          }
        }
      );
      formik.setFieldValue('home_delivery.sizes', updateAvailable);
      setActiveData(updateAvailable);
    }
  };

  const onChangeDefault = (id, name) => {
    if (name === 'skip_line') {
      let defaultStatus = formik.values.skip_line.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue('skip_line.sizes', defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === 'take_away') {
      let defaultStatus = formik.values.take_away.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue('take_away.sizes', defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === 'curb_side') {
      let defaultStatus = formik.values.curb_side.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue('curb_side.sizes', defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === 'dine_in') {
      let defaultStatus = formik.values.dine_in.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue('dine_in.sizes', defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === 'catering_banquet') {
      let defaultStatus = formik.values?.catering_banquet?.sizes?.map(
        (item, index) => {
          if (index === id) {
            return { ...item, isDefault: true };
          } else {
            return { ...item, isDefault: false };
          }
        }
      );
      formik.setFieldValue('catering_banquet.sizes', defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === 'home_delivery') {
      let defaultStatus = formik.values?.home_delivery?.sizes?.map(
        (item, index) => {
          if (index === id) {
            return { ...item, isDefault: true };
          } else {
            return { ...item, isDefault: false };
          }
        }
      );
      formik.setFieldValue('home_delivery.sizes', defaultStatus);
      setActiveData(defaultStatus);
    }
  };

  const onClickSaveModalDataSkipLine = (data) => {
    const existingTaxes = [];

    let skip_line_taxes = formik.values.skip_line.sur_charges;
    for (let i = 0; i < newTaxesSkipLine.length; i++) {
      if (data.id === newTaxesSkipLine[i].id) {
        let formData = {};
        formData.name = data.tax_name;
        formData.value = data.skip_line;
        formData.flag = data.tax_value;
        formData.id = data.id;
        formData.code = data.code;
        skip_line_taxes.push(formData);
        //formik.setFieldValue("",)
        //setTaxValues([...newTaxesSkipLine, data]);
      } else {
        existingTaxes.push(newTaxesSkipLine[i]);
      }
    }
    setNewTaxesSkipLine(existingTaxes);
    formik.setFieldValue('skip_line.sur_charges', skip_line_taxes);
  };

  // skip line end

  // take away start
  const [takeAwaySurcharge, setTakeAwaySurCharge] = useState(false);

  const onChangeTakeAway = () => {
    formik.setFieldValue('take_away.value', !formik.values.take_away.value);
  };

  const [newTaxesTakeAway, setNewTaxesTakeAway] = useState([]);

  const onClickSaveModalDataTakeAway = (data) => {
    const existingTaxes = [];

    let take_away_taxes = formik.values.take_away.sur_charges;
    for (let i = 0; i < newTaxesTakeAway.length; i++) {
      if (data.id === newTaxesTakeAway[i].id) {
        let formData = {};
        formData.name = data.tax_name;
        formData.value = data.take_away;
        formData.flag = data.tax_value;
        formData.id = data.id;
        formData.code = data.code;
        take_away_taxes.push(formData);
        //formik.setFieldValue("",)
        //setTaxValues([...newTaxesTakeAway, data]);
      } else {
        existingTaxes.push(newTaxesTakeAway[i]);
      }
    }
    setNewTaxesTakeAway(existingTaxes);
    formik.setFieldValue('take_away.sur_charges', take_away_taxes);
  };

  // take away end

  // curb side start
  const [curbSideSurcharge, setCurbSideSurCharge] = useState(false);

  const [newTaxesCurbSide, setNewTaxesCurbSide] = useState([]);

  const onChangeCurbSide = () => {
    formik.setFieldValue('curb_side.value', !formik.values.curb_side.value);
  };
  const onClickSaveModalDataCurbSide = (data) => {
    const existingTaxes = [];
    let curb_side_taxes = formik.values.curb_side.sur_charges;
    for (let i = 0; i < newTaxesCurbSide.length; i++) {
      if (data.id === newTaxesCurbSide[i].id) {
        let formData = {};
        formData.name = data.tax_name;
        formData.value = data.curb_side;
        formData.flag = data.tax_value;
        formData.id = data.id;
        formData.code = data.code;
        curb_side_taxes.push(formData);
        //formik.setFieldValue("",)
        //setTaxValues([...newTaxesTakeAway, data]);
      } else {
        existingTaxes.push(newTaxesCurbSide[i]);
      }
    }
    setNewTaxesCurbSide(existingTaxes);
    formik.setFieldValue('curb_Side.sur_charges', curb_side_taxes);
  };

  // curb side end

  // dine in side start

  const [dineInSurcharge, setDineInSurcharge] = useState(false);

  const [newTaxesDineIn, setNewTaxesDineIn] = useState([]);

  const onClickSaveModalDataDineIn = (data) => {
    const existingTaxes = [];
    let dine_in_taxes = formik.values.dine_in.sur_charges;
    for (let i = 0; i < newTaxesDineIn.length; i++) {
      if (data.id === newTaxesDineIn[i].id) {
        let formData = {};
        formData.name = data.tax_name;
        formData.value = data.dine_in_order;
        formData.flag = data.tax_value;
        formData.id = data.id;
        formData.code = data.code;
        dine_in_taxes.push(formData);
        //formik.setFieldValue("",)
        //setTaxValues([...newTaxesTakeAway, data]);
      } else {
        existingTaxes.push(newTaxesDineIn[i]);
      }
    }
    setNewTaxesDineIn(existingTaxes);
    formik.setFieldValue('dine_in.sur_charges', dine_in_taxes);
  };

  const onChangeDineIn = () => {
    formik.setFieldValue('dine_in.value', !formik.values.dine_in.value);
  };

  // Catering Banquet side start

  const [cateringBanquetSurcharge, setCateringBanquetSurcharge] =
    useState(false);

  const [newTaxesCateringBanquet, setNewTaxesCateringBanquet] = useState([]);

  const onClickSaveModalDataCateringBanquet = (data) => {
    const existingTaxes = [];
    let catering_banquet_taxes = formik.values?.catering_banquet?.sur_charges;
    for (let i = 0; i < newTaxesCateringBanquet.length; i++) {
      if (data.id === newTaxesCateringBanquet[i].id) {
        let formData = {};
        formData.name = data.tax_name;
        formData.value = data.catering_banquet;
        formData.flag = data.tax_value;
        formData.id = data.id;
        formData.code = data.code;
        catering_banquet_taxes.push(formData);
        //formik.setFieldValue("",)
        //setTaxValues([...newTaxesTakeAway, data]);
      } else {
        existingTaxes.push(newTaxesCateringBanquet[i]);
      }
    }
    setNewTaxesCateringBanquet(existingTaxes);
    formik.setFieldValue(
      'catering_banquet.sur_charges',
      catering_banquet_taxes
    );
  };

  const onChangeCateringBanquet = () => {
    formik.setFieldValue(
      'catering_banquet.value',
      !formik.values.catering_banquet.value
    );
  };

  // Home Delivery side start

  const [homeDeliverySurcharge, setHomeDeliverySurcharge] = useState(false);

  const [newTaxesHomeDelivery, setNewTaxesHomeDelivery] = useState([]);

  const onClickSaveModalDataHomeDelivery = (data) => {
    const existingTaxes = [];
    let home_delivery_taxes = formik.values?.home_delivery?.sur_charges;
    for (let i = 0; i < newTaxesHomeDelivery.length; i++) {
      if (data.id === newTaxesHomeDelivery[i].id) {
        let formData = {};
        formData.name = data.tax_name;
        formData.value = data.home_delivery;
        formData.flag = data.tax_value;
        formData.id = data.id;
        formData.code = data.code;
        home_delivery_taxes.push(formData);
        //formik.setFieldValue("",)
        //setTaxValues([...newTaxesTakeAway, data]);
      } else {
        existingTaxes.push(newTaxesHomeDelivery[i]);
      }
    }
    setNewTaxesHomeDelivery(existingTaxes);
    formik.setFieldValue('home_delivery.sur_charges', home_delivery_taxes);
  };

  const onChangeHomeDelivery = () => {
    if (
      props?.menuCategoryItems?.home_delivery !== undefined &&
      props?.menuCategoryItems?.home_delivery !== null &&
      props?.menuCategoryItems?.home_delivery?.sizes !== undefined &&
      props?.menuCategoryItems?.home_delivery?.sizes !== null &&
      props?.menuCategoryItems?.home_delivery?.sizes.length > 0
    ) {
      formik.setFieldValue(
        'home_delivery.value',
        !formik.values?.home_delivery?.value
      );
    } else {
      formik.setFieldValue(
        'home_delivery.value',
        !formik.values?.home_delivery?.value
      );
      formik.setFieldValue(
        'home_delivery.sizes',
        props?.menuCategoryItems?.size
      );
    }
  };
  console.log(history.location, props.itemAvailabilityPathName);

  const onSuccess = () => {
    //props.onChange(7);
    Alert.success(`<h4> Item Updated Sucessfully</h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    if (
      history.location.pathname.includes('additemavailablity/catalogverified')
    ) {
      history.push('/selecteditemsnew');
    } else if (props.itemAvailabilityPathName === '/itemavailablitydashboard') {
      history.push('/itemavailablitydashboard');
    } else if (props.itemAvailabilityPathName === '/menusetup-dashboard') {
      history.push('/menusetup-dashboard');
    } else if (history.location.pathname.includes('catalog')) {
      history.push('/casual-fine-dining/menusetup/selectmenu/selecteditemsnew');
    } else if (history.location.pathname.includes('catalogverified')) {
      history.push('/casual-fine-dining/menusetup/selectmenu/selecteditemsnew');
    } else if (
      history.location.pathname.includes('fastfood/menusetup/additem')
    ) {
      history.push('/fastfood/menusetup');
    } else if (
      history.location.pathname.includes('multi-service/menusetup/additem')
    ) {
      history.push('/multi-service/menusetup');
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push('/menusetup-dashboard');
    } else {
      history.push('/casual-fine-dining/menusetup');
    }
    window.scroll(0, 0);
  };

  const OnClickNextStep = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  // curb side end

  const formik = useFormik({
    initialValues: {
      skip_line: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
      take_away: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
      curb_side: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
      dine_in: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
      catering_banquet: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
      home_delivery: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
    },
    //validate,

    onSubmit: (values) => {
      // props.onChange(7);
      // window.scroll(0, 0);
      let formData = {};
      formData = { ...formik.values };
      const token = props.auth.user.accessToken;
      formData.currentState = 9;
      formData.runingTrack = 9;
      if (props.itemAvailabilityPathName === '/itemavailablitydashboard') {
        formData.menu_id = props?.menuData ? props?.menuData?.menuId : '';
      } else {
        formData.menu_id = props?.ActiveMenu ? props?.ActiveMenu?._id : '';
      }

      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
      // console.log(formData);
    },
  });

  const [dataForEdit, setDataForEdit] = useState();
  const [showEditSkipLine, setShowEditSkipLine] = useState(false);
  const [showEditTakeAway, setShowEditTakeAway] = useState(false);
  const [showEditCurbSide, setShowEditCurbSide] = useState(false);
  const [showEditDineIn, setShowEditDineIn] = useState(false);
  const [showEditCateringBanquet, setShowEditCateringBanquet] = useState(false);
  const [showEditHomeDelivery, setShowEditHomeDelivery] = useState(false);

  const onClickEditItem = (e, id, name, data) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    setEditIndex(id);
    setDataForEdit(data);
    if (name === 'skip_line') {
      setShowEditSkipLine(true);
    } else if (name === 'take_away') {
      setShowEditTakeAway(true);
    } else if (name === 'curb_side') {
      setShowEditCurbSide(true);
    } else if (name === 'dine_in') {
      setShowEditDineIn(true);
    } else if (name === 'catering_banquet') {
      setShowEditCateringBanquet(true);
    } else if (name === 'home_delivery') {
      setShowEditHomeDelivery(true);
    }
  };

  const updatedEditData = (updatedData) => {
    if (activeNameSurcharge === 'skip_line') {
      formik.setFieldValue(`skip_line.sizes[${editIndex}]`, updatedData);
    } else if (activeNameSurcharge === 'take_away') {
      formik.setFieldValue(`take_away.sizes[${editIndex}]`, updatedData);
    } else if (activeNameSurcharge === 'curb_side') {
      formik.setFieldValue(`curb_side.sizes[${editIndex}]`, updatedData);
    } else if (activeNameSurcharge === 'dine_in') {
      formik.setFieldValue(`dine_in.sizes[${editIndex}]`, updatedData);
    } else if (activeNameSurcharge === 'catering_banquet') {
      formik.setFieldValue(`catering_banquet.sizes[${editIndex}]`, updatedData);
    } else if (activeNameSurcharge === 'home_delivery') {
      formik.setFieldValue(`home_delivery.sizes[${editIndex}]`, updatedData);
    }

    setActiveNameSurcharge('');
    setEditIndex('');
    setDataForEdit('');
    setShowEditSkipLine(false);
    setShowEditTakeAway(false);
    setShowEditCurbSide(false);
    setShowEditDineIn(false);
    setShowEditCateringBanquet(false);
    setShowEditHomeDelivery(false);
  };

  const onChangeValue = (e, name, indexId) => {
    let existingData = [];
    let formikData = formik.values[name].sur_charges;

    for (let i = 0; i < formikData.length; i++) {
      if (indexId === i) {
        let data = JSON.parse(JSON.stringify(formikData[i]));
        data.value = e;
        existingData.push(data);
      } else {
        existingData.push(formikData[i]);
      }
    }
    formik.setFieldValue(`${name}.sur_charges`, existingData);
  };

  const removeTax = (item, formikName) => {
    if (formikName === 'take_away') {
      let existingData = [...formik.values.take_away.sur_charges];

      existingData = existingData.filter((data) => {
        return data.code !== item.code;
      });
      formik.setFieldValue('take_away.sur_charges', existingData);
      let existingNewTaxes = [...newTaxesTakeAway];
      existingNewTaxes.push(item);
      setNewTaxesTakeAway(existingNewTaxes);
    } else if (formikName === 'curb_side') {
      let existingData = [...formik.values.curb_side.sur_charges];

      existingData = existingData.filter((data) => {
        return data.code !== item.code;
      });
      formik.setFieldValue('curb_side.sur_charges', existingData);

      let existingNewTaxes = [...newTaxesCurbSide];
      existingNewTaxes.push(item);
      setNewTaxesCurbSide(existingNewTaxes);
    } else if (formikName === 'dine_in') {
      let existingData = [...formik.values.dine_in.sur_charges];

      existingData = existingData.filter((data) => {
        return data.code !== item.code;
      });
      formik.setFieldValue('dine_in.sur_charges', existingData);
      let existingNewTaxes = [...newTaxesDineIn];
      existingNewTaxes.push(item);
      setNewTaxesDineIn(existingNewTaxes);
    } else if (formikName === 'catering_banquet') {
      let existingData = [...formik.values?.catering_banquet?.sur_charges];

      existingData = existingData.filter((data) => {
        return data.code !== item.code;
      });
      formik.setFieldValue('catering_banquet.sur_charges', existingData);
      let existingNewTaxes = [...newTaxesCateringBanquet];
      existingNewTaxes.push(item);
      setNewTaxesCateringBanquet(existingNewTaxes);
    } else if (formikName === 'home_delivery') {
      let existingData = [...formik.values?.home_delivery?.sur_charges];
      existingData = existingData.filter((data) => {
        return data.code !== item.code;
      });
      formik.setFieldValue('home_delivery.sur_charges', existingData);
      let existingNewTaxes = [...newTaxesHomeDelivery];
      existingNewTaxes.push(item);
      setNewTaxesHomeDelivery(existingNewTaxes);
    } else if (formikName === 'skip_line') {
      let existingData = [...formik.values.skip_line.sur_charges];

      existingData = existingData.filter((data) => {
        return data.code !== item.code;
      });
      formik.setFieldValue('skip_line.sur_charges', existingData);
      let existingNewTaxes = [...newTaxesSkipLine];
      // item.tax_name = item.name;
      // existingNewTaxes.push(item);
      setNewTaxesSkipLine(existingNewTaxes);
    }
  };

  const formikSurcharge = useFormik({
    initialValues: {
      name: '',
      value: '',
      flag: 'PERCENTAGE',
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(128, 'Must be 128 characters or less')
        .required('Surcharge name  is required'),
      value: yup.number().required('This field is required'),
    }),
    onSubmit: (values) => {
      if (activeNameSurcharge === 'skip_line' && !editStatus) {
        let oldSurcharges = formik.values.skip_line.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue('skip_line.sur_charges', oldSurcharges);
        setSkipLineSurCharge(false);
      } else if (activeNameSurcharge === 'skip_line' && editStatus) {
        let oldSurcharges = formik.values.skip_line.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`skip_line.sur_charges`, oldSurcharges);
        setEditIndex('');
        setEditStatus(false);
        setSkipLineSurCharge(false);
      } else if (activeNameSurcharge === 'take_away' && !editStatus) {
        let oldSurcharges = formik.values.take_away.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue('take_away.sur_charges', oldSurcharges);
        setTakeAwaySurCharge(false);
      } else if (activeNameSurcharge === 'take_away' && editStatus) {
        let oldSurcharges = formik.values.take_away.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`take_away.sur_charges`, oldSurcharges);
        setEditIndex('');
        setEditStatus(false);
        setTakeAwaySurCharge(false);
      } else if (activeNameSurcharge === 'curb_side' && !editStatus) {
        let oldSurcharges = formik.values.curb_side.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue('curb_side.sur_charges', oldSurcharges);
        setCurbSideSurCharge(false);
      } else if (activeNameSurcharge === 'curb_side' && editStatus) {
        let oldSurcharges = formik.values.take_away.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`curb_side.sur_charges`, oldSurcharges);
        setEditIndex('');
        setEditStatus(false);
        setCurbSideSurCharge(false);
      } else if (activeNameSurcharge === 'dine_in' && !editStatus) {
        let oldSurcharges = formik.values.dine_in.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue('dine_in.sur_charges', oldSurcharges);
        setDineInSurcharge(false);
      } else if (activeNameSurcharge === 'dine_in' && editStatus) {
        let oldSurcharges = formik.values.dine_in.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`dine_in.sur_charges`, oldSurcharges);
        setEditIndex('');
        setEditStatus(false);
        setDineInSurcharge(false);
      } else if (activeNameSurcharge === 'catering_banquet' && !editStatus) {
        let oldSurcharges = formik.values?.catering_banquet?.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue('catering_banquet.sur_charges', oldSurcharges);
        setCateringBanquetSurcharge(false);
      } else if (activeNameSurcharge === 'catering_banquet' && editStatus) {
        let oldSurcharges = formik.values?.catering_banquet?.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`catering_banquet.sur_charges`, oldSurcharges);
        setEditIndex('');
        setEditStatus(false);
        setCateringBanquetSurcharge(false);
      } else if (activeNameSurcharge === 'home_delivery' && !editStatus) {
        let oldSurcharges = formik.values?.home_delivery?.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue('home_delivery.sur_charges', oldSurcharges);
        setHomeDeliverySurcharge(false);
      } else if (activeNameSurcharge === 'home_delivery' && editStatus) {
        let oldSurcharges = formik.values?.home_delivery?.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`home_delivery.sur_charges`, oldSurcharges);
        setEditIndex('');
        setEditStatus(false);
        setHomeDeliverySurcharge(false);
      }

      formikSurcharge.resetForm();
    },
  });
  const [addsurcharges, setAddSurcharges] = React.useState(false);
  const [addsurchargesSkipLine, setAddSurchargesSKipLine] = useState(false);
  const openAddSurchargesSkipLine = () => {
    setAddSurchargesSKipLine(true);
  };

  const openAddSurcharges = () => {
    setAddSurcharges(true);
  };
  const closeAddSurcharges = () => {
    setAddSurcharges(false);
  };
  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      if (data.itemSize === 'SINGLE') {
        data.size[0].description = data.name;
        data.size[0].isDefault = true;
        data.size[0].available = true;
      }
      if (data.currentState === 9 || data?.pos_item_id) {
        formik.setFieldValue('skip_line', data.skip_line);
        formik.setFieldValue('take_away', data.take_away);
        formik.setFieldValue('curb_side', data.curb_side);
        formik.setFieldValue('dine_in', data.dine_in);
        formik.setFieldValue('catering_banquet', data?.catering_banquet);
        formik.setFieldValue('home_delivery', data?.home_delivery);
      } else {
        formik.setFieldValue('skip_line.sizes', data.size);
        formik.setFieldValue('take_away.sizes', data.size);
        formik.setFieldValue('curb_side.sizes', data.size);
        formik.setFieldValue('dine_in.sizes', data.size);
        formik.setFieldValue('catering_banquet.sizes', data.size);
        formik.setFieldValue('home_delivery.sizes', data.size);
      }
    }
  }, [props.menuCategoryItems]);

  useEffect(() => {
    // if (props.servicesEnabled && props.servicesEnabled.take_away.value) {
    //   setShowTakeAway(true);
    // }

    if (
      history.location.pathname.includes('fastfood/menusetup/additem') ||
      (props.serviceType && props.serviceType.fast_food_dining)
    ) {
      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.self_serve &&
        props.servicesEnabledFastFood.self_serve.value
      ) {
        setShowSkeipTheLine(true);
      } else {
        setStep(2);
      }

      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.cubside_delivery &&
        props.servicesEnabledFastFood.cubside_delivery.value
      ) {
        setShowCurbSide(true);
      }
      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.dine_in_order &&
        props.servicesEnabledFastFood.dine_in_order.value
      ) {
        setShowDineIn(true);
      }
      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.catering_banquet &&
        props.servicesEnabledFastFood.catering_banquet.value
      ) {
        setShowCateringBanquet(true);
      }
      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.home_delivery &&
        props.servicesEnabledFastFood.home_delivery.value
      ) {
        setShowHomeDelivery(true);
      }
    } else if (
      history.location.pathname.includes('multi-service/menusetup/additem') ||
      (props.serviceType && props.serviceType.multi_service_business)
    ) {
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.self_serve &&
        props.servicesEnabledMultiService.self_serve.value
      ) {
        setShowSkeipTheLine(true);
      } else {
        setStep(2);
      }
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.cubside_delivery &&
        props.servicesEnabledMultiService.cubside_delivery.value
      ) {
        setShowCurbSide(true);
      }
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.dine_in_order &&
        props.servicesEnabledMultiService.dine_in_order.value
      ) {
        setShowDineIn(true);
      }
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.catering_banquet &&
        props.servicesEnabledMultiService.catering_banquet.value
      ) {
        setShowCateringBanquet(true);
      }
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.home_delivery &&
        props.servicesEnabledMultiService.home_delivery.value
      ) {
        setShowHomeDelivery(true);
      }
    } else {
      setStep(2);
      if (
        props.servicesEnabled &&
        props.servicesEnabled.cubside_delivery.value
      ) {
        setShowCurbSide(true);
      }
      if (props.servicesEnabled && props.servicesEnabled.dine_in_order.value) {
        setShowDineIn(true);
      }
      if (
        props.servicesEnabled &&
        props.servicesEnabled.catering_banquet &&
        props.servicesEnabled.catering_banquet.value
      ) {
        setShowCateringBanquet(true);
      }
      if (
        props.servicesEnabled &&
        props.servicesEnabled.home_delivery &&
        props.servicesEnabled.home_delivery.value
      ) {
        setShowHomeDelivery(true);
      }
    }
  }, [
    props.servicesEnabled,
    props.servicesEnabledFastFood,
    props.servicesEnabledMultiService,
    props.serviceType,
  ]);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup_without_loader(token);
  }, []);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      if (data.currentState !== 9 && !data?.pos_item_id) {
        let charges_data = [];
        let skip_line_taxes = [];
        let dine_in_taxes = [];
        let curb_side_taxes = [];
        let take_away_taxes = [];
        let catering_banquet_taxes = [];
        let home_delivery_taxes = [];
        if (
          props &&
          props.menuCategory &&
          props.subscriptionData &&
          props.subscriptionData.tax_values
        ) {
          for (let i = 0; i < props.menuCategory.length; i++) {
            for (let j = 0; j < props.menuCategory[i].items.length; j++) {
              if (props.activeItemId === props.menuCategory[i].items[j]._id) {
                charges_data = [...props.menuCategory[i].charges];
                break;
              }
            }
          }

          let id = [];
          let newTaxes = [];

          for (let i = 0; i < charges_data.length; i++) {
            id.push(charges_data[i].id);
          }

          for (let j = 0; j < props.subscriptionData.tax_code.length; j++) {
            if (!id.includes(props.subscriptionData.tax_code[j].id)) {
              let prepData = {
                id: props.subscriptionData.tax_code[j].id,
                tax_name: props.subscriptionData.tax_code[j].description,
                code: props.subscriptionData.tax_code[j].code,
                tax_value: 'PERCENTAGE',
                take_away: 0,
                curb_side: 0,
                dine_in_order: 0,
                catering_banquet: 0,
                home_delivery: 0,
                skip_line: 0,
              };
              newTaxes.push(prepData);
            }
          }
          setNewTaxesSkipLine(newTaxes);
          setNewTaxesTakeAway(newTaxes);
          setNewTaxesDineIn(newTaxes);
          setNewTaxesCurbSide(newTaxes);
          setNewTaxesCateringBanquet(newTaxes);
          setNewTaxesHomeDelivery(newTaxes);

          for (let k = 0; k < charges_data.length; k++) {
            if (charges_data[k] && charges_data[k].dine_in_order) {
              let formData = {};
              formData.name = charges_data[k].tax_name;
              formData.value = charges_data[k].dine_in_order;
              formData.flag = charges_data[k].tax_value;
              dine_in_taxes.push(formData);
            }
            if (charges_data[k] && charges_data[k].take_away) {
              let formData = {};
              formData.name = charges_data[k].tax_name;
              formData.value = charges_data[k].take_away;
              formData.flag = charges_data[k].tax_value;
              formData.code = charges_data[k].code;
              take_away_taxes.push(formData);
            }
            if (charges_data[k] && charges_data[k].curb_side) {
              let formData = {};
              formData.name = charges_data[k].tax_name;
              formData.value = charges_data[k].curb_side;
              formData.flag = charges_data[k].tax_value;
              formData.code = charges_data[k].code;
              curb_side_taxes.push(formData);
            }
            if (charges_data[k] && charges_data[k].skip_line) {
              let formData = {};
              formData.name = charges_data[k].tax_name;
              formData.value = charges_data[k].skip_line;
              formData.flag = charges_data[k].tax_value;
              formData.code = charges_data[k].code;
              skip_line_taxes.push(formData);
            }
            if (charges_data[k] && charges_data[k].catering_banquet) {
              let formData = {};
              formData.name = charges_data[k].tax_name;
              formData.value = charges_data[k].catering_banquet;
              formData.flag = charges_data[k].tax_value;
              formData.code = charges_data[k].code;
              catering_banquet_taxes.push(formData);
            }
            if (charges_data[k] && charges_data[k].home_delivery) {
              let formData = {};
              formData.name = charges_data[k].tax_name;
              formData.value = charges_data[k].home_delivery;
              formData.flag = charges_data[k].tax_value;
              formData.code = charges_data[k].code;
              home_delivery_taxes.push(formData);
            }
          }

          formik.setFieldValue('skip_line.sur_charges', skip_line_taxes);
          formik.setFieldValue('dine_in.sur_charges', dine_in_taxes);
          formik.setFieldValue('curb_side.sur_charges', curb_side_taxes);
          formik.setFieldValue('take_away.sur_charges', take_away_taxes);
          formik.setFieldValue(
            'catering_banquet.sur_charges',
            catering_banquet_taxes
          );
          formik.setFieldValue(
            'home_delivery.sur_charges',
            home_delivery_taxes
          );
        }
      } else {
        // take away starts
        let taxCodeTakeAway = [];
        let newTakeAwayTaxes = [];
        for (let i = 0; i < formik.values.take_away.sur_charges.length; i++) {
          taxCodeTakeAway.push(formik.values.take_away.sur_charges[i].code);
        }

        for (let i = 0; i < props.subscriptionData.tax_code.length; i++) {
          if (
            !taxCodeTakeAway.includes(props.subscriptionData.tax_code[i].code)
          ) {
            let prepData = {
              id: props.subscriptionData.tax_code[i].id,
              tax_name: props.subscriptionData.tax_code[i].description,
              code: props.subscriptionData.tax_code[i].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            //newTaxes.push(prepData);
            newTakeAwayTaxes.push(prepData);
          }
        }
        setNewTaxesTakeAway(newTakeAwayTaxes);
        // take away ends

        // skip line starts
        let taxCodeSkipLine = [];
        let newTaxesSKipLine = [];
        for (let i = 0; i < formik.values.skip_line.sur_charges.length; i++) {
          taxCodeSkipLine.push(formik.values.skip_line.sur_charges[i].code);
        }

        for (let i = 0; i < props.subscriptionData.tax_code.length; i++) {
          if (
            !taxCodeSkipLine.includes(props.subscriptionData.tax_code[i].code)
          ) {
            let prepData = {
              id: props.subscriptionData.tax_code[i].id,
              tax_name: props.subscriptionData.tax_code[i].description,
              code: props.subscriptionData.tax_code[i].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            //newTaxes.push(prepData);
            newTaxesSKipLine.push(prepData);
          }
        }
        setNewTaxesSkipLine(newTaxesSKipLine);
        // skip line ends

        // curb side starts
        let taxCodeCurbSide = [];
        let newCurbSideTaxes = [];
        for (let i = 0; i < formik.values.curb_side.sur_charges.length; i++) {
          taxCodeCurbSide.push(formik.values.curb_side.sur_charges[i].code);
        }

        for (let i = 0; i < props.subscriptionData.tax_code.length; i++) {
          if (
            !taxCodeCurbSide.includes(props.subscriptionData.tax_code[i].code)
          ) {
            let prepData = {
              id: props.subscriptionData.tax_code[i].id,
              tax_name: props.subscriptionData.tax_code[i].description,
              code: props.subscriptionData.tax_code[i].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            //newTaxes.push(prepData);
            newCurbSideTaxes.push(prepData);
          }
        }
        setNewTaxesCurbSide(newCurbSideTaxes);
        // curb side  ends

        // Dine in Start
        let taxCodeDineIN = [];
        let newDineInTaxes = [];
        for (let i = 0; i < formik.values.dine_in.sur_charges.length; i++) {
          taxCodeDineIN.push(formik.values.dine_in.sur_charges[i].code);
        }

        for (let i = 0; i < props.subscriptionData.tax_code.length; i++) {
          if (
            !taxCodeDineIN.includes(props.subscriptionData.tax_code[i].code)
          ) {
            let prepData = {
              id: props.subscriptionData.tax_code[i].id,
              tax_name: props.subscriptionData.tax_code[i].description,
              code: props.subscriptionData.tax_code[i].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            //newTaxes.push(prepData);
            newDineInTaxes.push(prepData);
          }
        }
        setNewTaxesDineIn(newDineInTaxes);
        // Dine in ends

        // catering banquet in Start
        let taxCodeCateringBanquet = [];
        let newCateringBanquetTaxes = [];
        for (
          let i = 0;
          i < formik.values?.catering_banquet?.sur_charges.length;
          i++
        ) {
          taxCodeCateringBanquet.push(
            formik.values?.catering_banquet?.sur_charges[i].code
          );
        }

        for (let i = 0; i < props.subscriptionData.tax_code.length; i++) {
          if (
            !taxCodeCateringBanquet.includes(
              props.subscriptionData.tax_code[i].code
            )
          ) {
            let prepData = {
              id: props.subscriptionData.tax_code[i].id,
              tax_name: props.subscriptionData.tax_code[i].description,
              code: props.subscriptionData.tax_code[i].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            //newTaxes.push(prepData);
            newCateringBanquetTaxes.push(prepData);
          }
        }
        setNewTaxesCateringBanquet(newCateringBanquetTaxes);
        // catering banquet in ends

        // Home Delivery Start
        let taxCodeHomeDelivery = [];
        let newHomeDeliveryTaxes = [];
        for (
          let i = 0;
          i < formik.values?.home_delivery?.sur_charges?.length;
          i++
        ) {
          taxCodeHomeDelivery.push(
            formik.values?.home_delivery?.sur_charges[i]?.code
          );
        }

        for (let i = 0; i < props?.subscriptionData?.tax_code?.length; i++) {
          if (
            !taxCodeHomeDelivery.includes(
              props?.subscriptionData?.tax_code[i]?.code
            )
          ) {
            let prepData = {
              id: props?.subscriptionData?.tax_code[i]?.id,
              tax_name: props?.subscriptionData?.tax_code[i]?.description,
              code: props?.subscriptionData?.tax_code[i]?.code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            //newTaxes.push(prepData);
            newHomeDeliveryTaxes.push(prepData);
          }
        }
        setNewTaxesHomeDelivery(newHomeDeliveryTaxes);
        // Home Delivery ends
      }
    }
  }, [props?.menuCategory, props?.menuCategoryItems, props?.subscriptionData]);

  return (
    <React.Fragment>
      <Form style={{ marginBottom: '4rem' }}>
        {props.origin ? null : (
          <>
            <div className="mb-4">
              <TopTextReusableComponent
                headingText="New Item"
                headingParagraph="Manage your food items"
              />
            </div>
            <div className="bg-gray px-3 py-2">
              <Row>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Ext Item ID :
                    </div>
                    <FormControl
                      className={'w-100 bg-white md-p-9'}
                      variant="outlined"
                    >
                      <OutlinedInput
                        disabled
                        value={
                          props.menuCategoryItems &&
                          props.menuCategoryItems.ext_id
                        }
                      />
                    </FormControl>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              className="displayItemsName f11-400 enRadius5 my-4"
              style={{ height: 50 }}
            >
              {props.menuCategoryItems && props.menuCategoryItems.name}
            </div>
          </>
        )}
        {step === 1 && showSkipTheLine && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require('../../../../../../../../assets/images/UserManagement/Icons-02.svg')}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Skip The Line
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.skip_line.value}
                  onChange={() => onChangeSkipLine()}
                />
              </div>
            </div>
            <>
              {formik.values.skip_line.value ? (
                <>
                  {showEditSkipLine ? (
                    <ServicesEditReuse
                      data={dataForEdit}
                      updatedData={(newData) => updatedEditData(newData)}
                    />
                  ) : (
                    <> </>
                  )}
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        'add-button-icon-reusable add-button-icon-reusable-blue'
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.skip_line.sizes.length !== 0 ? (
                    <Row>
                      <Col md={1} xs={2} className="pb-4 p-0">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={3} xs={2} className="pb-4">
                        <div className="f11-700">Item Name</div>
                      </Col>
                      <Col md={2} xs={1} className="pb-4">
                        <div className="f11-700">Item Price</div>
                      </Col>
                      <Col md={2} xs={3} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          onClick={() => handleShowDetails('skip_line')}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.skip_line.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={1} xs={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                'skip_line'
                              )
                            }
                          />
                        </Col>
                        <Col md={2} xs={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefault"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, 'skip_line')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={3} xs={2} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={2} xs={1} className="pb-2">
                          <div className="f11-400">{item.price}</div>
                        </Col>
                        <Col md={4} xs={3} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            {!props.menuCategoryItems?.pos_item_id && (
                              <IconButton className="mr-2 p-0">
                                <Image
                                  src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                  alt="edit item"
                                  title="edit item"
                                  className="w-20px"
                                  onClick={(e) =>
                                    onClickEditItem(e, index, 'skip_line', item)
                                  }
                                />
                              </IconButton>
                            )}
                            <IconButton className="p-0">
                              <Image
                                src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                alt="delete item"
                                title="delete item"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, 'skip_line')
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}

                  <Row className="align-items-center py-3">
                    <Col md={6} xs={8}>
                      <div className="f14-700">
                        Maintain tax and other charges
                      </div>
                    </Col>
                    <Col md={6} xs={4}>
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.skip_line.sur_charges_value}
                        checkedBox={formik.values.skip_line.sur_charges_value}
                        // onChange={() => {
                        //   {
                        //     //setTakeAwaySurCharge(!takeAwaySurcharge);
                        //     formik.setFieldValue("abc", "hello");
                        //   }
                        // }}
                        onChange={() =>
                          formik.setFieldValue(
                            'skip_line.sur_charges_value',
                            !formik.values.skip_line.sur_charges_value
                          )
                        }
                      />
                    </Col>
                  </Row>

                  {formik.values.skip_line.sur_charges_value ? (
                    <Fragment>
                      {formik.values.skip_line.sur_charges.map(
                        (item, index) => (
                          <TaxesServices
                            noEdit={props.menuCategoryItems?.pos_item_id}
                            changeHandle={(e) =>
                              onChangeValue(e, 'skip_line', index)
                            }
                            removeTax={() => removeTax(item, 'skip_line')}
                            service_name="Skip Line"
                            key={index}
                            tax_name={item.name}
                            take_away={item.value}
                            tax_value={item.flag}
                            orderingData={{
                              take_away: { value: true },
                            }}
                          />
                        )
                      )}

                      {newTaxesSkipLine.length > 0 &&
                      !props.menuCategoryItems?.pos_item_id ? (
                        <Fragment>
                          <div
                            className="f14-400 "
                            style={{
                              color: '#2096F3',
                              cursor: 'pointer',
                            }}
                            onClick={openAddSurcharges}
                            style={{ marginBottom: '40px' }}
                          >
                            Add/Maintain Tax/Surchages
                          </div>
                          <AddSurchargesModel
                            //tax_value={item.tax_value}
                            closeAddSurcharges={closeAddSurcharges}
                            open={addsurcharges}
                            taxInfo={newTaxesSkipLine}
                            //take_away={showTakeAway}
                            skip_line={showSkipTheLine}
                            //dine_in_order={showDineIn}
                            //curb_side={showCurbSide}
                            //catering_banquet={false}
                            //home_delivery={false}
                            // cubside_delivery={showCurbSide}
                            onClickSaveModalData={(data) =>
                              onClickSaveModalDataSkipLine(data)
                            }
                          />
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                  ) : (
                    <> </>
                  )}
                </>
              ) : (
                <> </>
              )}
            </>

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                //onClick={() => handleStep2BackButton()}
                onClick={() => onClickBack()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                //onClick={() => handleStep2Change()}
                onClick={() => handleStep1Change()}
              />
            </div>
          </React.Fragment>
        )}
        {step === 2 && showTakeAway && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require('../../../../../../../../assets/images/UserManagement/Icons-02.svg')}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Take Away
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.take_away.value}
                  onChange={() => onChangeTakeAway()}
                />
              </div>
            </div>
            <>
              {formik.values.take_away.value ? (
                <>
                  {showEditTakeAway ? (
                    <ServicesEditReuse
                      data={dataForEdit}
                      updatedData={(newData) => updatedEditData(newData)}
                    />
                  ) : (
                    <> </>
                  )}
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        'add-button-icon-reusable add-button-icon-reusable-blue'
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.take_away.sizes.length !== 0 ? (
                    <Row>
                      <Col md={1} xs={2} className="pb-4 p-0">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={3} xs={2} className="pb-4">
                        <div className="f11-700">Item Name</div>
                      </Col>
                      <Col md={2} xs={1} className="pb-4">
                        <div className="f11-700">Item Price</div>
                      </Col>
                      <Col md={2} xs={3} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          onClick={() => handleShowDetails('take_away')}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.take_away.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={1} xs={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                'take_away'
                              )
                            }
                          />
                        </Col>
                        <Col md={2} xs={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefaultTakeaway"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, 'take_away')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={3} xs={2} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={2} xs={1} className="pb-2">
                          <div className="f11-400">{item.price}</div>
                        </Col>
                        <Col md={4} xs={3} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            {!props.menuCategoryItems?.pos_item_id && (
                              <IconButton className="mr-2 p-0">
                                <Image
                                  src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                  alt="edit item"
                                  title="edit item"
                                  className="w-20px"
                                  onClick={(e) =>
                                    onClickEditItem(e, index, 'take_away', item)
                                  }
                                />
                              </IconButton>
                            )}
                            <IconButton className="p-0">
                              <Image
                                src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                alt="delete item"
                                title="delete item"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, 'take_away')
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}

                  <Row className="align-items-center py-3">
                    <Col md={6} xs={8}>
                      <div className="f14-700">
                        Maintain tax and other charges
                      </div>
                    </Col>
                    <Col md={6} xs={4}>
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.take_away.sur_charges_value}
                        checkedBox={formik.values.take_away.sur_charges_value}
                        // onChange={() => {
                        //   {
                        //     //setTakeAwaySurCharge(!takeAwaySurcharge);
                        //     formik.setFieldValue("abc", "hello");
                        //   }
                        // }}
                        onChange={() =>
                          formik.setFieldValue(
                            'take_away.sur_charges_value',
                            !formik.values.take_away.sur_charges_value
                          )
                        }
                      />
                    </Col>
                  </Row>

                  {formik.values.take_away.sur_charges_value ? (
                    <Fragment>
                      {formik.values.take_away.sur_charges.map(
                        (item, index) => (
                          <TaxesServices
                            changeHandle={(e) =>
                              onChangeValue(e, 'take_away', index)
                            }
                            removeTax={() => removeTax(item, 'take_away')}
                            service_name="Take Away"
                            key={index}
                            tax_name={item.name}
                            take_away={item.value}
                            tax_value={item.flag}
                            orderingData={{
                              take_away: { value: true },
                            }}
                            noEdit={props.menuCategoryItems?.pos_item_id}
                          />
                        )
                      )}

                      {newTaxesTakeAway.length > 0 &&
                      !props.menuCategoryItems?.pos_item_id ? (
                        <Fragment>
                          <div
                            className="f14-400 "
                            style={{
                              color: '#2096F3',
                              cursor: 'pointer',
                            }}
                            onClick={openAddSurcharges}
                          >
                            Add/Maintain Tax/Surchages
                          </div>
                          <AddSurchargesModel
                            //tax_value={item.tax_value}
                            closeAddSurcharges={closeAddSurcharges}
                            open={addsurcharges}
                            taxInfo={newTaxesTakeAway}
                            take_away={showTakeAway}
                            //skip_line={showSkipTheLine}
                            //dine_in_order={showDineIn}
                            //curb_side={showCurbSide}
                            //catering_banquet={false}
                            //home_delivery={false}
                            // cubside_delivery={showCurbSide}
                            onClickSaveModalData={(data) =>
                              onClickSaveModalDataTakeAway(data)
                            }
                          />
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                  ) : (
                    <> </>
                  )}
                </>
              ) : (
                <> </>
              )}
            </>

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStep2BackButton()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStep2Change()}
              />
            </div>
          </React.Fragment>
        )}
        {step === 3 && showCurbSide && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require('../../../../../../../../assets/images/UserManagement/Icons-03.svg')}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Curb Side
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.curb_side.value}
                  onChange={() => onChangeCurbSide()}
                />
              </div>
            </div>
            <>
              {formik.values.curb_side.value ? (
                <>
                  <>
                    {showEditCurbSide ? (
                      <ServicesEditReuse
                        data={dataForEdit}
                        updatedData={(newData) => updatedEditData(newData)}
                      />
                    ) : (
                      <> </>
                    )}
                  </>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        'add-button-icon-reusable add-button-icon-reusable-blue'
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.curb_side.sizes.length !== 0 ? (
                    <Row>
                      <Col md={1} xs={2} className="pb-4 p-0">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={3} xs={2} className="pb-4">
                        <div className="f11-700">Item Name</div>
                      </Col>
                      <Col md={2} xs={1} className="pb-4">
                        <div className="f11-700">Item Price</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          onClick={() => handleShowDetails('curb_side')}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.curb_side.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={1} xs={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                'curb_side'
                              )
                            }
                          />
                        </Col>
                        <Col md={2} xs={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefault"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, 'curb_side')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={3} xs={2} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={2} xs={1} className="pb-2">
                          <div className="f11-400">{item.price}</div>
                        </Col>
                        <Col md={4} xs={3} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            {!props.menuCategoryItems?.pos_item_id && (
                              <IconButton className="mr-2 p-0">
                                <Image
                                  src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                  alt="edit item"
                                  title="edit item"
                                  className="w-20px"
                                  onClick={(e) =>
                                    onClickEditItem(e, index, 'curb_side', item)
                                  }
                                />
                              </IconButton>
                            )}
                            <IconButton className="p-0">
                              <Image
                                src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                alt="delete item"
                                title="delete item"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, 'curb_side')
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}

                  <Row className="align-items-center py-3">
                    <Col md={6} xs={8}>
                      <div className="f14-700">
                        Maintain tax and other charges
                      </div>
                    </Col>
                    <Col md={6} xs={4}>
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.curb_side.sur_charges_value}
                        checkedBox={formik.values.curb_side.sur_charges_value}
                        // onChange={() =>
                        //   setCurbSideSurCharge(!curbSideSurcharge)
                        // }
                        onChange={() =>
                          formik.setFieldValue(
                            'curb_side.sur_charges_value',
                            !formik.values.curb_side.sur_charges_value
                          )
                        }
                      />
                    </Col>
                  </Row>
                  {formik.values.curb_side.sur_charges_value ? (
                    <Fragment>
                      {formik.values.curb_side.sur_charges.map(
                        (item, index) => (
                          <TaxesServices
                            noEdit={props.menuCategoryItems?.pos_item_id}
                            changeHandle={(e) =>
                              onChangeValue(e, 'curb_side', index)
                            }
                            removeTax={() => removeTax(item, 'curb_side')}
                            service_name="Curb Side"
                            key={index}
                            tax_name={item.name}
                            take_away={item.value}
                            tax_value={item.flag}
                            orderingData={{
                              take_away: { value: true },
                            }}
                          />
                        )
                      )}
                      {newTaxesCurbSide.length > 0 &&
                      !props.menuCategoryItems?.pos_item_id ? (
                        <Fragment>
                          <div
                            className="f14-400 "
                            style={{
                              color: '#2096F3',
                              cursor: 'pointer',
                            }}
                            onClick={openAddSurcharges}
                          >
                            Add/Maintain Tax/Surchages
                          </div>
                          <AddSurchargesModel
                            //tax_value={item.tax_value}
                            closeAddSurcharges={closeAddSurcharges}
                            open={addsurcharges}
                            taxInfo={newTaxesCurbSide}
                            //take_away={showTakeAway}
                            //skip_line={showSkipTheLine}
                            //dine_in_order={showDineIn}
                            curb_side={showCurbSide}
                            //catering_banquet={false}
                            //home_delivery={false}
                            // cubside_delivery={showCurbSide}
                            onClickSaveModalData={(data) =>
                              onClickSaveModalDataCurbSide(data)
                            }
                          />
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                  ) : (
                    <Fragment></Fragment>
                  )}
                </>
              ) : (
                <> </>
              )}
            </>

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStep3BackButton()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStep3Change()}
              />
            </div>
          </React.Fragment>
        )}
        {step === 4 && showDineIn && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require('../../../../../../../../assets/images/UserManagement/Icons-03.svg')}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Dine In
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.dine_in.value}
                  onChange={() => onChangeDineIn()}
                />
              </div>
            </div>
            <>
              {formik.values.dine_in.value ? (
                <>
                  {showEditDineIn ? (
                    <ServicesEditReuse
                      data={dataForEdit}
                      updatedData={(newData) => updatedEditData(newData)}
                    />
                  ) : (
                    <> </>
                  )}

                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        'add-button-icon-reusable add-button-icon-reusable-blue'
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.dine_in.sizes.length !== 0 ? (
                    <Row>
                      <Col md={1} xs={2} className="pb-4 p-0">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={3} xs={2} className="pb-4">
                        <div className="f11-700">Item Name</div>
                      </Col>
                      <Col md={2} xs={1} className="pb-4">
                        <div className="f11-700">Item Price</div>
                      </Col>
                      <Col md={2} xs={3} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          onClick={() => handleShowDetails('dine_in')}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.dine_in.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={1} xs={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                'dine_in'
                              )
                            }
                          />
                        </Col>
                        <Col md={2} xs={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefaultDineIn"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, 'dine_in')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={3} xs={2} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={2} xs={1} className="pb-2">
                          <div className="f11-400">{item.price}</div>
                        </Col>
                        <Col md={4} xs={2} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            {!props.menuCategoryItems?.pos_item_id && (
                              <IconButton className="mr-2 p-0">
                                <Image
                                  src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                  alt="edit item"
                                  title="edit item"
                                  className="w-20px"
                                  onClick={(e) =>
                                    onClickEditItem(e, index, 'dine_in', item)
                                  }
                                />
                              </IconButton>
                            )}
                            <IconButton className="p-0">
                              <Image
                                src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                alt="delete item"
                                title="delete item"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, 'dine_in')
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}

                  <Row className="align-items-center py-3">
                    <Col md={6} xs={8}>
                      <div className="f14-700">
                        Maintain tax and other charges
                      </div>
                    </Col>
                    <Col md={6} xs={4}>
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.dine_in.sur_charges_value}
                        checkedBox={formik.values.dine_in.sur_charges_value}
                        //onChange={() => setDineInSurcharge(!dineInSurcharge)}
                        onChange={() =>
                          formik.setFieldValue(
                            'dine_in.sur_charges_value',
                            !formik.values.dine_in.sur_charges_value
                          )
                        }
                      />
                    </Col>
                  </Row>
                  {formik.values.dine_in.sur_charges_value ? (
                    <Fragment>
                      {formik.values.dine_in.sur_charges.map((item, index) => (
                        <TaxesServices
                          noEdit={props.menuCategoryItems?.pos_item_id}
                          changeHandle={(e) =>
                            onChangeValue(e, 'dine_in', index)
                          }
                          removeTax={() => removeTax(item, 'dine_in')}
                          service_name="Dine In"
                          key={index}
                          tax_name={item.name}
                          take_away={item.value}
                          tax_value={item.flag}
                          orderingData={{
                            take_away: { value: true },
                          }}
                        />
                      ))}
                      {newTaxesDineIn.length > 0 &&
                      !props.menuCategoryItems?.pos_item_id ? (
                        <Fragment>
                          <div
                            className="f14-400 "
                            style={{
                              color: '#2096F3',
                              cursor: 'pointer',
                            }}
                            onClick={openAddSurcharges}
                          >
                            Add/Maintain Tax/Surchages
                          </div>
                          <AddSurchargesModel
                            //tax_value={item.tax_value}
                            closeAddSurcharges={closeAddSurcharges}
                            open={addsurcharges}
                            taxInfo={newTaxesDineIn}
                            dine_in_order={showDineIn}
                            onClickSaveModalData={(data) =>
                              onClickSaveModalDataDineIn(data)
                            }
                          />
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                  ) : (
                    <> </>
                  )}
                </>
              ) : (
                <> </>
              )}
            </>

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStep4BackButton()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStep4Change()}
              />
            </div>
          </React.Fragment>
        )}
        {step === 5 && showCateringBanquet && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    // src={require("../../../../../../../../assets/images/UserManagement/Icons-03.svg")}
                    src={require('../../../../../../../../assets/images/Orders/icons/catering.svg')}
                    alt="add"
                    // className="w-20px"
                  />
                </div>
                Catering Banquet
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik?.values?.catering_banquet?.value}
                  onChange={() => onChangeCateringBanquet()}
                />
              </div>
            </div>
            <>
              {formik?.values?.catering_banquet?.value ? (
                <>
                  {showEditCateringBanquet ? (
                    <ServicesEditReuse
                      data={dataForEdit}
                      updatedData={(newData) => updatedEditData(newData)}
                    />
                  ) : (
                    <> </>
                  )}

                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        'add-button-icon-reusable add-button-icon-reusable-blue'
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik?.values?.catering_banquet?.sizes.length !== 0 ? (
                    <Row>
                      <Col md={1} xs={2} className="pb-4 p-0">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={3} xs={2} className="pb-4">
                        <div className="f11-700">Item Name</div>
                      </Col>
                      <Col md={2} xs={1} className="pb-4">
                        <div className="f11-700">Item Price</div>
                      </Col>
                      <Col md={2} xs={3} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} xs={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          onClick={() => handleShowDetails('catering_banquet')}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}
                  {formik?.values?.catering_banquet?.sizes?.map(
                    (item, index) => (
                      <Fragment key={index}>
                        <Row className="align-items-center">
                          <Col md={1} xs={2} className="pb-2">
                            <Form.Check
                              label="1"
                              inline
                              className="enCheckBoxOnly d-grid"
                              checked={item.available}
                              onChange={(e) =>
                                onChangeAvaiblity(
                                  item.available,
                                  index,
                                  'catering_banquet'
                                )
                              }
                            />
                          </Col>
                          <Col md={2} xs={2} className="pb-2">
                            <label className="enRadioWithText small d-grid">
                              <input
                                type="radio"
                                name="setDefaultCateringBanquet"
                                checked={item.isDefault}
                                onChange={(e) =>
                                  onChangeDefault(index, 'catering_banquet')
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          </Col>
                          <Col md={3} xs={2} className="pb-2">
                            <div className="f11-400">{item.description}</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-2">
                            <div className="f11-400">{item.price}</div>
                          </Col>
                          <Col md={4} xs={2} className="pb-2">
                            <div className="d-flex align-itmes-center">
                              {!props.menuCategoryItems?.pos_item_id && (
                                <IconButton className="mr-2 p-0">
                                  <Image
                                    src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                    alt="edit item"
                                    title="edit item"
                                    className="w-20px"
                                    onClick={(e) =>
                                      onClickEditItem(
                                        e,
                                        index,
                                        'catering_banquet',
                                        item
                                      )
                                    }
                                  />
                                </IconButton>
                              )}
                              <IconButton className="p-0">
                                <Image
                                  src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                  alt="delete item"
                                  title="delete item"
                                  className="w-20px"
                                  onClick={(e) =>
                                    onClickDeleteItem(
                                      e,
                                      index,
                                      'catering_banquet'
                                    )
                                  }
                                />
                              </IconButton>
                            </div>
                          </Col>
                        </Row>
                        <hr />
                      </Fragment>
                    )
                  )}

                  <Row className="align-items-center py-3">
                    <Col md={6} xs={8}>
                      <div className="f14-700">
                        Maintain tax and other charges
                      </div>
                    </Col>
                    <Col md={6} xs={4}>
                      <ToggleButtonWithYesNo
                        activeClass={
                          formik?.values?.catering_banquet?.sur_charges_value
                        }
                        checkedBox={
                          formik?.values?.catering_banquet?.sur_charges_value
                        }
                        //onChange={() => setDineInSurcharge(!dineInSurcharge)}
                        onChange={() =>
                          formik.setFieldValue(
                            'catering_banquet.sur_charges_value',
                            !formik?.values?.catering_banquet?.sur_charges_value
                          )
                        }
                      />
                    </Col>
                  </Row>
                  {formik?.values?.catering_banquet?.sur_charges_value ? (
                    <Fragment>
                      {formik?.values?.catering_banquet?.sur_charges?.map(
                        (item, index) => (
                          <TaxesServices
                            noEdit={props.menuCategoryItems?.pos_item_id}
                            changeHandle={(e) =>
                              onChangeValue(e, 'catering_banquet', index)
                            }
                            removeTax={() =>
                              removeTax(item, 'catering_banquet')
                            }
                            service_name="Catering Banquet"
                            key={index}
                            tax_name={item.name}
                            take_away={item.value}
                            tax_value={item.flag}
                            orderingData={{
                              take_away: { value: true },
                            }}
                          />
                        )
                      )}
                      {newTaxesCateringBanquet.length > 0 &&
                      !props.menuCategoryItems?.pos_item_id ? (
                        <Fragment>
                          <div
                            className="f14-400 "
                            style={{
                              color: '#2096F3',
                              cursor: 'pointer',
                            }}
                            onClick={openAddSurcharges}
                          >
                            Add/Maintain Tax/Surchages
                          </div>
                          <AddSurchargesModel
                            //tax_value={item.tax_value}
                            closeAddSurcharges={closeAddSurcharges}
                            open={addsurcharges}
                            taxInfo={newTaxesCateringBanquet}
                            catering_banquet={showCateringBanquet}
                            //home_delivery={false}
                            onClickSaveModalData={(data) =>
                              onClickSaveModalDataCateringBanquet(data)
                            }
                          />
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                  ) : (
                    <> </>
                  )}
                </>
              ) : (
                <> </>
              )}
            </>

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStep5BackButton()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStep5Change()}
              />
            </div>
          </React.Fragment>
        )}
        {step === 6 && showHomeDelivery && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    // src={require("../../../../../../../../assets/images/UserManagement/Icons-03.svg")}
                    src={require('../../../../../../../../assets/images/Orders/icons/delivery.svg')}
                    alt="add"
                    // className="w-20px"
                  />
                </div>
                Home Delivery
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik?.values?.home_delivery?.value}
                  onChange={() => onChangeHomeDelivery()}
                />
              </div>
            </div>
            <>
              {formik?.values?.home_delivery?.value ? (
                <>
                  {showEditHomeDelivery ? (
                    <ServicesEditReuse
                      data={dataForEdit}
                      updatedData={(newData) => updatedEditData(newData)}
                    />
                  ) : (
                    <> </>
                  )}

                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        'add-button-icon-reusable add-button-icon-reusable-blue'
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik?.values?.home_delivery?.sizes &&
                  formik?.values?.home_delivery?.sizes.length !== 0 ? (
                    <Col className="col-12">
                      <Row>
                        <Col md={1} xs={2} className="pb-4 p-0">
                          <div className="f11-700">Available</div>
                        </Col>
                        <Col md={2} xs={2} className="pb-4">
                          <div className="f11-700">Set Default</div>
                        </Col>
                        <Col md={3} xs={2} className="pb-4">
                          <div className="f11-700">Item Name</div>
                        </Col>
                        <Col md={2} xs={1} className="pb-4">
                          <div className="f11-700">Item Price</div>
                        </Col>
                        <Col md={2} xs={3} className="pb-3">
                          <div className="f11-700">Action</div>
                        </Col>
                        <Col md={2} xs={2} className="pb-3">
                          <button
                            type="button"
                            className={
                              'add-button-icon-reusable add-button-icon-reusable-blue'
                            }
                            onClick={() => handleShowDetails('home_delivery')}
                          >
                            See more
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  ) : (
                    <> </>
                  )}

                  {formik?.values?.home_delivery?.sizes?.map((item, index) => (
                    <Fragment key={index}>
                      <Col className="col-12">
                        <Row className="align-items-center">
                          <Col md={1} xs={2} className="pb-2">
                            <Form.Check
                              label="1"
                              inline
                              className="enCheckBoxOnly d-grid"
                              checked={item.available}
                              onChange={(e) =>
                                onChangeAvaiblity(
                                  item.available,
                                  index,
                                  'home_delivery'
                                )
                              }
                            />
                          </Col>
                          <Col md={2} xs={2} className="pb-2">
                            <label className="enRadioWithText small d-grid">
                              <input
                                type="radio"
                                name="setDefaultHomeDelivery"
                                checked={item.isDefault}
                                onChange={(e) =>
                                  onChangeDefault(index, 'home_delivery')
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          </Col>
                          <Col md={3} xs={2} className="pb-2">
                            <div className="f11-400">{item.description}</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-2">
                            <div className="f11-400">{item.price}</div>
                          </Col>
                          <Col md={4} xs={2} className="pb-2">
                            <div className="d-flex align-itmes-center">
                              {!props.menuCategoryItems?.pos_item_id && (
                                <IconButton className="mr-2 p-0">
                                  <Image
                                    src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                    alt="edit item"
                                    title="edit item"
                                    className="w-20px"
                                    onClick={(e) =>
                                      onClickEditItem(
                                        e,
                                        index,
                                        'home_delivery',
                                        item
                                      )
                                    }
                                  />
                                </IconButton>
                              )}
                              <IconButton className="p-0">
                                <Image
                                  src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                  alt="delete item"
                                  title="delete item"
                                  className="w-20px"
                                  onClick={(e) =>
                                    onClickDeleteItem(e, index, 'home_delivery')
                                  }
                                />
                              </IconButton>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <hr />
                    </Fragment>
                  ))}

                  <Row className="align-items-center py-3">
                    <Col md={6} xs={8}>
                      <div className="f14-700">
                        Maintain tax and other charges
                      </div>
                    </Col>
                    <Col md={6} xs={4}>
                      <ToggleButtonWithYesNo
                        activeClass={
                          formik?.values?.home_delivery?.sur_charges_value
                        }
                        checkedBox={
                          formik?.values?.home_delivery?.sur_charges_value
                        }
                        //onChange={() => setHomeDeliverySurcharge(!HomeDeliverySurcharge)}
                        onChange={() =>
                          formik.setFieldValue(
                            'home_delivery.sur_charges_value',
                            !formik?.values?.home_delivery?.sur_charges_value
                          )
                        }
                      />
                    </Col>
                  </Row>
                  {formik?.values?.home_delivery?.sur_charges_value ? (
                    <Fragment>
                      {formik?.values?.home_delivery?.sur_charges?.map(
                        (item, index) => (
                          <TaxesServices
                            noEdit={props.menuCategoryItems?.pos_item_id}
                            changeHandle={(e) =>
                              onChangeValue(e, 'home_delivery', index)
                            }
                            removeTax={() => removeTax(item, 'home_delivery')}
                            service_name="Home Delivery"
                            key={index}
                            tax_name={item.name}
                            take_away={item.value}
                            tax_value={item.flag}
                            orderingData={{
                              take_away: { value: true },
                            }}
                          />
                        )
                      )}
                      {newTaxesHomeDelivery.length > 0 &&
                      !props.menuCategoryItems?.pos_item_id ? (
                        <Fragment>
                          <div
                            className="f14-400 "
                            style={{
                              color: '#2096F3',
                              cursor: 'pointer',
                            }}
                            onClick={openAddSurcharges}
                          >
                            Add/Maintain Tax/Surchages
                          </div>
                          <AddSurchargesModel
                            //tax_value={item.tax_value}
                            closeAddSurcharges={closeAddSurcharges}
                            open={addsurcharges}
                            taxInfo={newTaxesHomeDelivery}
                            home_delivery={showHomeDelivery}
                            onClickSaveModalData={(data) =>
                              onClickSaveModalDataHomeDelivery(data)
                            }
                          />
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                  ) : (
                    <> </>
                  )}
                </>
              ) : (
                <> </>
              )}
            </>

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStep6BackButton()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStepChange(7)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 7 && (
          <React.Fragment>
            <div className="f14-700 justify-content-between">
              <div>Available for Services</div>
              <div style={{ color: '#1396FF' }}>Reset availability</div>
            </div>
            {showSkipTheLine ? (
              <Fragment>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                    <div className="enIconShadow mr-3">
                      <Image
                        src={require('../../../../../../../../assets/images/UserManagement/Icons-02.svg')}
                        alt="add"
                        className="w-20px"
                      />
                    </div>
                    Skip The Line
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.skip_line.value}
                      onChange={() => onChangeSkipLine()}
                    />
                  </div>
                </div>
                <>
                  {formik.values.skip_line.value ? (
                    <>
                      {showEditSkipLine ? (
                        <ServicesEditReuse
                          data={dataForEdit}
                          updatedData={(newData) => updatedEditData(newData)}
                        />
                      ) : (
                        <> </>
                      )}
                      <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                        <div className="f12-700">
                          Set Availability and Price :
                        </div>
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          // onClick={handleShowDetails}
                          onClick={(e) => redirectToStep3(e)}
                        >
                          Missing a Size ? Add
                        </button>
                      </div>
                      {formik.values.skip_line.sizes.length !== 0 ? (
                        <Row>
                          <Col md={1} xs={2} className="pb-4 p-0">
                            <div className="f11-700">Available</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-4">
                            <div className="f11-700">Set Default</div>
                          </Col>
                          <Col md={3} xs={2} className="pb-4">
                            <div className="f11-700">Item Name</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-4">
                            <div className="f11-700">Item Price</div>
                          </Col>
                          <Col md={2} xs={3} className="pb-3">
                            <div className="f11-700">Action</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-3">
                            <button
                              type="button"
                              className={
                                'add-button-icon-reusable add-button-icon-reusable-blue'
                              }
                              onClick={() => handleShowDetails('skip_line')}
                            >
                              See more
                            </button>
                          </Col>
                        </Row>
                      ) : (
                        <> </>
                      )}
                      {formik.values.skip_line.sizes.map((item, index) => (
                        <Fragment key={index}>
                          <Row className="align-items-center">
                            <Col md={1} xs={2} className="pb-2">
                              <Form.Check
                                label="1"
                                inline
                                className="enCheckBoxOnly d-grid"
                                checked={item.available}
                                onChange={(e) =>
                                  onChangeAvaiblity(
                                    item.available,
                                    index,
                                    'skip_line'
                                  )
                                }
                              />
                            </Col>
                            <Col md={2} xs={2} className="pb-2">
                              <label className="enRadioWithText small d-grid">
                                <input
                                  type="radio"
                                  name="setDefaultSkipLine"
                                  checked={item.isDefault}
                                  onChange={(e) =>
                                    onChangeDefault(index, 'skip_line')
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                            <Col md={3} xs={2} className="pb-2">
                              <div className="f11-400">{item.description}</div>
                            </Col>
                            <Col md={2} xs={1} className="pb-2">
                              <div className="f11-400">{item.price}</div>
                            </Col>
                            <Col md={4} xs={3} className="pb-2">
                              <div className="d-flex align-itmes-center">
                                {!props.menuCategoryItems?.pos_item_id && (
                                  <IconButton className="mr-2 p-0">
                                    <Image
                                      src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                      alt="edit item"
                                      title="edit item"
                                      className="w-20px"
                                      onClick={(e) =>
                                        onClickEditItem(
                                          e,
                                          index,
                                          'skip_line',
                                          item
                                        )
                                      }
                                    />
                                  </IconButton>
                                )}
                                <IconButton className="p-0">
                                  <Image
                                    src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                    alt="add"
                                    title="add"
                                    className="w-20px"
                                    onClick={(e) =>
                                      onClickDeleteItem(e, index, 'skip_line')
                                    }
                                  />
                                </IconButton>
                              </div>
                            </Col>
                          </Row>
                          <hr />
                        </Fragment>
                      ))}

                      <Row className="align-items-center py-3">
                        <Col md={6} xs={8}>
                          <div className="f14-700">
                            Maintain tax and other charges
                          </div>
                        </Col>
                        <Col md={6} xs={4}>
                          <ToggleButtonWithYesNo
                            activeClass={
                              formik.values.skip_line.sur_charges_value
                            }
                            checkedBox={
                              formik.values.skip_line.sur_charges_value
                            }
                            // onChange={() =>
                            //   setTakeAwaySurCharge(!takeAwaySurcharge)
                            // }
                            onChange={() =>
                              formik.setFieldValue(
                                'skip_line.sur_charges_value',
                                !formik.values.skip_line.sur_charges_value
                              )
                            }
                          />
                        </Col>
                      </Row>
                      {formik.values.skip_line.sur_charges_value ? (
                        <Fragment>
                          <div className="f12-700 mb-2">Surcharge:</div>
                          {formik.values.skip_line.sur_charges.map(
                            (item, index) => (
                              <TaxesServices
                                noEdit={props.menuCategoryItems?.pos_item_id}
                                changeHandle={(e, name) =>
                                  onChangeValue(e, 'skip_line', index)
                                }
                                removeTax={() => removeTax(item, 'skip_line')}
                                service_name="skip line"
                                key={index}
                                tax_name={item.name}
                                take_away={item.value}
                                tax_value={item.flag}
                                orderingData={{
                                  take_away: { value: true },
                                }}
                              />
                            )
                          )}
                          {newTaxesSkipLine.length > 0 &&
                          !props.menuCategoryItems?.pos_item_id ? (
                            <Fragment>
                              <div
                                className="f14-400 "
                                style={{
                                  color: '#2096F3',
                                  cursor: 'pointer',
                                }}
                                onClick={openAddSurcharges}
                              >
                                Add/Maintain Tax/Surchages
                              </div>
                              <AddSurchargesModel
                                //tax_value={item.tax_value}
                                closeAddSurcharges={closeAddSurcharges}
                                open={addsurcharges}
                                taxInfo={newTaxesSkipLine}
                                //take_away={showSkipTheLine}
                                skip_line={showSkipTheLine}
                                //dine_in_order={showDineIn}
                                //curb_side={showCurbSide}
                                //catering_banquet={false}
                                //home_delivery={false}
                                // cubside_delivery={showCurbSide}
                                onClickSaveModalData={(data) =>
                                  onClickSaveModalDataSkipLine(data)
                                }
                              />
                            </Fragment>
                          ) : (
                            <> </>
                          )}
                        </Fragment>
                      ) : (
                        <Fragment></Fragment>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                </>
              </Fragment>
            ) : (
              <></>
            )}
            <hr />
            {showTakeAway ? (
              <Fragment>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                    <div className="enIconShadow mr-3">
                      <Image
                        src={require('../../../../../../../../assets/images/UserManagement/Icons-02.svg')}
                        alt="add"
                        className="w-20px"
                      />
                    </div>
                    Take Away
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.take_away.value}
                      onChange={() => onChangeTakeAway()}
                    />
                  </div>
                </div>
                <>
                  {formik.values.take_away.value ? (
                    <>
                      {showEditTakeAway ? (
                        <ServicesEditReuse
                          data={dataForEdit}
                          updatedData={(newData) => updatedEditData(newData)}
                        />
                      ) : (
                        <> </>
                      )}
                      <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                        <div className="f12-700">
                          Set Availability and Price :
                        </div>
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          // onClick={handleShowDetails}
                          onClick={(e) => redirectToStep3(e)}
                        >
                          Missing a Size ? Add
                        </button>
                      </div>
                      {formik.values.take_away.sizes.length !== 0 ? (
                        <Row>
                          <Col md={1} xs={2} className="pb-4 p-0">
                            <div className="f11-700">Available</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-4">
                            <div className="f11-700">Set Default</div>
                          </Col>
                          <Col md={3} xs={2} className="pb-4">
                            <div className="f11-700">Item Name</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-4">
                            <div className="f11-700">Item Price</div>
                          </Col>
                          <Col md={2} xs={3} className="pb-3">
                            <div className="f11-700">Action</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-3">
                            <button
                              type="button"
                              className={
                                'add-button-icon-reusable add-button-icon-reusable-blue'
                              }
                              onClick={() => handleShowDetails('take_away')}
                            >
                              See more
                            </button>
                          </Col>
                        </Row>
                      ) : (
                        <> </>
                      )}
                      {formik.values.take_away.sizes.map((item, index) => (
                        <Fragment key={index}>
                          <Row className="align-items-center">
                            <Col md={1} xs={2} className="pb-2">
                              <Form.Check
                                label="1"
                                inline
                                className="enCheckBoxOnly d-grid"
                                checked={item.available}
                                onChange={(e) =>
                                  onChangeAvaiblity(
                                    item.available,
                                    index,
                                    'take_away'
                                  )
                                }
                              />
                            </Col>
                            <Col md={2} xs={2} className="pb-2">
                              <label className="enRadioWithText small d-grid">
                                <input
                                  type="radio"
                                  name="setDefaultTakeAwayFinal"
                                  checked={item.isDefault}
                                  onChange={(e) =>
                                    onChangeDefault(index, 'take_away')
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                            <Col md={3} xs={2} className="pb-2">
                              <div className="f11-400">{item.description}</div>
                            </Col>
                            <Col md={2} xs={1} className="pb-2">
                              <div className="f11-400">{item.price}</div>
                            </Col>
                            <Col md={4} xs={3} className="pb-2">
                              <div className="d-flex align-itmes-center">
                                {!props.menuCategoryItems?.pos_item_id && (
                                  <IconButton className="mr-2 p-0">
                                    <Image
                                      src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                      alt="edit item"
                                      title="edit item"
                                      className="w-20px"
                                      onClick={(e) =>
                                        onClickEditItem(
                                          e,
                                          index,
                                          'take_away',
                                          item
                                        )
                                      }
                                    />
                                  </IconButton>
                                )}
                                <IconButton className="p-0">
                                  <Image
                                    src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                    alt="add"
                                    title="add"
                                    className="w-20px"
                                    onClick={(e) =>
                                      onClickDeleteItem(e, index, 'take_away')
                                    }
                                  />
                                </IconButton>
                              </div>
                            </Col>
                          </Row>
                          <hr />
                        </Fragment>
                      ))}

                      <Row className="align-items-center py-3">
                        <Col md={6} xs={8}>
                          <div className="f14-700">
                            Maintain tax and other charges
                          </div>
                        </Col>
                        <Col md={6} xs={4}>
                          <ToggleButtonWithYesNo
                            activeClass={
                              formik.values.take_away.sur_charges_value
                            }
                            checkedBox={
                              formik.values.take_away.sur_charges_value
                            }
                            // onChange={() =>
                            //   setTakeAwaySurCharge(!takeAwaySurcharge)
                            // }
                            onChange={() =>
                              formik.setFieldValue(
                                'take_away.sur_charges_value',
                                !formik.values.take_away.sur_charges_value
                              )
                            }
                          />
                        </Col>
                      </Row>
                      {formik.values.take_away.sur_charges_value ? (
                        <Fragment>
                          <div className="f12-700 mb-2">Surcharge:</div>
                          {formik.values.take_away.sur_charges.map(
                            (item, index) => (
                              <TaxesServices
                                noEdit={props.menuCategoryItems?.pos_item_id}
                                changeHandle={(e, name) =>
                                  onChangeValue(e, 'take_away', index)
                                }
                                removeTax={() => removeTax(item, 'take_away')}
                                service_name="Take Away"
                                key={index}
                                tax_name={item.name}
                                take_away={item.value}
                                tax_value={item.flag}
                                orderingData={{
                                  take_away: { value: true },
                                }}
                              />
                            )
                          )}
                          {newTaxesTakeAway.length > 0 &&
                          !props.menuCategoryItems?.pos_item_id ? (
                            <Fragment>
                              <div
                                className="f14-400 "
                                style={{
                                  color: '#2096F3',
                                  cursor: 'pointer',
                                }}
                                onClick={openAddSurcharges}
                              >
                                Add/Maintain Tax/Surchages
                              </div>
                              <AddSurchargesModel
                                //tax_value={item.tax_value}
                                closeAddSurcharges={closeAddSurcharges}
                                open={addsurcharges}
                                taxInfo={newTaxesTakeAway}
                                take_away={showTakeAway}
                                //skip_line={showSkipTheLine}
                                //dine_in_order={showDineIn}
                                //curb_side={showCurbSide}
                                //catering_banquet={false}
                                //home_delivery={false}
                                // cubside_delivery={showCurbSide}
                                onClickSaveModalData={(data) =>
                                  onClickSaveModalDataTakeAway(data)
                                }
                              />
                            </Fragment>
                          ) : (
                            <> </>
                          )}
                        </Fragment>
                      ) : (
                        <Fragment></Fragment>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                </>
              </Fragment>
            ) : (
              <></>
            )}
            <hr />
            {showCurbSide ? (
              <Fragment>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                    <div className="enIconShadow mr-3">
                      <Image
                        src={require('../../../../../../../../assets/images/UserManagement/Icons-03.svg')}
                        alt="add"
                        className="w-20px"
                      />
                    </div>
                    Curb Side
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.curb_side.value}
                      onChange={() => onChangeCurbSide()}
                    />
                  </div>
                </div>
                <>
                  {formik.values.curb_side.value ? (
                    <>
                      {showEditCurbSide ? (
                        <ServicesEditReuse
                          data={dataForEdit}
                          updatedData={(newData) => updatedEditData(newData)}
                        />
                      ) : (
                        <> </>
                      )}
                      <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                        <div className="f12-700">
                          Set Availability and Price :
                        </div>
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          // onClick={handleShowDetails}
                          onClick={(e) => redirectToStep3(e)}
                        >
                          Missing a Size ? Add
                        </button>
                      </div>
                      {formik.values.curb_side.sizes.length !== 0 ? (
                        <Row>
                          <Col md={1} xs={2} className="pb-4 p-0">
                            <div className="f11-700">Available</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-4">
                            <div className="f11-700">Set Default</div>
                          </Col>
                          <Col md={3} xs={2} className="pb-4">
                            <div className="f11-700">Item Name</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-4">
                            <div className="f11-700">Item Price</div>
                          </Col>
                          <Col md={2} xs={3} className="pb-3">
                            <div className="f11-700">Action</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-3">
                            <button
                              type="button"
                              className={
                                'add-button-icon-reusable add-button-icon-reusable-blue'
                              }
                              onClick={() => handleShowDetails('curb_side')}
                            >
                              See more
                            </button>
                          </Col>
                        </Row>
                      ) : (
                        <> </>
                      )}
                      {formik.values.curb_side.sizes.map((item, index) => (
                        <Fragment key={index}>
                          <Row className="align-items-center">
                            <Col md={1} xs={2} className="pb-2">
                              <Form.Check
                                label="1"
                                inline
                                className="enCheckBoxOnly d-grid"
                                checked={item.available}
                                onChange={(e) =>
                                  onChangeAvaiblity(
                                    item.available,
                                    index,
                                    'curb_side'
                                  )
                                }
                              />
                            </Col>
                            <Col md={2} xs={2} className="pb-2">
                              <label className="enRadioWithText small d-grid">
                                <input
                                  type="radio"
                                  name="setDefaultCurbSideFinal"
                                  checked={item.isDefault}
                                  onChange={(e) =>
                                    onChangeDefault(index, 'curb_side')
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                            <Col md={3} xs={2} className="pb-2">
                              <div className="f11-400">{item.description}</div>
                            </Col>
                            <Col md={2} xs={1} className="pb-2">
                              <div className="f11-400">{item.price}</div>
                            </Col>
                            <Col md={4} xs={3} className="pb-2">
                              <div className="d-flex align-itmes-center">
                                {!props.menuCategoryItems?.pos_item_id && (
                                  <IconButton className="mr-2 p-0">
                                    <Image
                                      src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                      alt="edit item"
                                      title="edit item"
                                      className="w-20px"
                                      onClick={(e) =>
                                        onClickEditItem(
                                          e,
                                          index,
                                          'curb_side',
                                          item
                                        )
                                      }
                                    />
                                  </IconButton>
                                )}
                                <IconButton className="p-0">
                                  <Image
                                    src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                    alt="delete item"
                                    title="delete item"
                                    className="w-20px"
                                    onClick={(e) =>
                                      onClickDeleteItem(e, index, 'curb_side')
                                    }
                                  />
                                </IconButton>
                              </div>
                            </Col>
                          </Row>
                          <hr />
                        </Fragment>
                      ))}
                      <Row className="align-items-center py-3">
                        <Col md={6} xs={8}>
                          <div className="f14-700">
                            Maintain tax and other charges
                          </div>
                        </Col>
                        <Col md={6} xs={4}>
                          <ToggleButtonWithYesNo
                            activeClass={
                              formik.values.curb_side.sur_charges_value
                            }
                            checkedBox={
                              formik.values.curb_side.sur_charges_value
                            }
                            // onChange={() =>
                            //   setCurbSideSurCharge(!curbSideSurcharge)
                            // }
                            onChange={() =>
                              formik.setFieldValue(
                                'curb_side.sur_charges_value',
                                !formik.values.curb_side.sur_charges_value
                              )
                            }
                          />
                        </Col>
                      </Row>
                      {formik.values.curb_side.sur_charges_value ? (
                        <Fragment>
                          {formik.values.curb_side.sur_charges.map(
                            (item, index) => (
                              <TaxesServices
                                noEdit={props.menuCategoryItems?.pos_item_id}
                                changeHandle={(e) =>
                                  onChangeValue(e, 'curb_side', index)
                                }
                                removeTax={() => removeTax(item, 'curb_side')}
                                service_name="Curb Side"
                                key={index}
                                tax_name={item.name}
                                take_away={item.value}
                                tax_value={item.flag}
                                orderingData={{
                                  take_away: { value: true },
                                }}
                              />
                            )
                          )}
                          {newTaxesCurbSide.length > 0 &&
                          !props.menuCategoryItems?.pos_item_id ? (
                            <Fragment>
                              <div
                                className="f14-400 "
                                style={{
                                  color: '#2096F3',
                                  cursor: 'pointer',
                                }}
                                onClick={openAddSurcharges}
                              >
                                Add/Maintain Tax/Surchages
                              </div>
                              <AddSurchargesModel
                                //tax_value={item.tax_value}
                                closeAddSurcharges={closeAddSurcharges}
                                open={addsurcharges}
                                taxInfo={newTaxesCurbSide}
                                //take_away={showTakeAway}
                                //skip_line={showSkipTheLine}
                                //dine_in_order={showDineIn}
                                curb_side={showCurbSide}
                                //catering_banquet={false}
                                //home_delivery={false}
                                // cubside_delivery={showCurbSide}
                                onClickSaveModalData={(data) =>
                                  onClickSaveModalDataCurbSide(data)
                                }
                              />
                            </Fragment>
                          ) : (
                            <> </>
                          )}
                        </Fragment>
                      ) : (
                        <Fragment></Fragment>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                </>
              </Fragment>
            ) : (
              <> </>
            )}
            <hr />
            {showDineIn ? (
              <Fragment>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                    <div className="enIconShadow mr-3">
                      <Image
                        src={require('../../../../../../../../assets/images/UserManagement/Icons-03.svg')}
                        alt="add"
                        className="w-20px"
                      />
                    </div>
                    Dine In
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.dine_in.value}
                      onChange={() => onChangeDineIn()}
                    />
                  </div>
                </div>
                <>
                  {formik.values.dine_in.value ? (
                    <>
                      {showEditDineIn ? (
                        <ServicesEditReuse
                          data={dataForEdit}
                          updatedData={(newData) => updatedEditData(newData)}
                        />
                      ) : (
                        <> </>
                      )}
                      <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                        <div className="f12-700">
                          Set Availability and Price :
                        </div>
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          // onClick={handleShowDetails}
                          onClick={(e) => redirectToStep3(e)}
                        >
                          Missing a Size ? Add
                        </button>
                      </div>
                      {formik.values.dine_in.sizes.length !== 0 ? (
                        <Row>
                          <Col md={1} xs={2} className="pb-4 p-0">
                            <div className="f11-700">Available</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-4">
                            <div className="f11-700">Set Default</div>
                          </Col>
                          <Col md={3} xs={2} className="pb-4">
                            <div className="f11-700">Item Name</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-4">
                            <div className="f11-700">Item Price</div>
                          </Col>
                          <Col md={2} xs={3} className="pb-3">
                            <div className="f11-700">Action</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-3">
                            <button
                              type="button"
                              className={
                                'add-button-icon-reusable add-button-icon-reusable-blue'
                              }
                              onClick={() => handleShowDetails('dine_in')}
                            >
                              See more
                            </button>
                          </Col>
                        </Row>
                      ) : (
                        <> </>
                      )}
                      {formik.values.dine_in.sizes.map((item, index) => (
                        <Fragment key={index}>
                          <Row className="align-items-center">
                            <Col md={1} xs={2} className="pb-2">
                              <Form.Check
                                label="1"
                                inline
                                className="enCheckBoxOnly d-grid"
                                checked={item.available}
                                onChange={(e) =>
                                  onChangeAvaiblity(
                                    item.available,
                                    index,
                                    'dine_in'
                                  )
                                }
                              />
                            </Col>
                            <Col md={2} xs={2} className="pb-2">
                              <label className="enRadioWithText small d-grid">
                                <input
                                  type="radio"
                                  name="setDefaultDineInFinal"
                                  checked={item.isDefault}
                                  onChange={(e) =>
                                    onChangeDefault(index, 'dine_in')
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                            <Col md={3} xs={2} className="pb-2">
                              <div className="f11-400">{item.description}</div>
                            </Col>
                            <Col md={2} xs={1} className="pb-2">
                              <div className="f11-400">{item.price}</div>
                            </Col>
                            <Col md={4} xs={3} className="pb-2">
                              <div className="d-flex align-itmes-center">
                                {!props.menuCategoryItems?.pos_item_id && (
                                  <IconButton className="mr-2 p-0">
                                    <Image
                                      src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                      alt="edit item"
                                      title="edit item"
                                      className="w-20px"
                                      onClick={(e) =>
                                        onClickEditItem(
                                          e,
                                          index,
                                          'dine_in',
                                          item
                                        )
                                      }
                                    />
                                  </IconButton>
                                )}
                                <IconButton className="p-0">
                                  <Image
                                    src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                    alt="delete item"
                                    title="delete item"
                                    className="w-20px"
                                    onClick={(e) =>
                                      onClickDeleteItem(e, index, 'dine_in')
                                    }
                                  />
                                </IconButton>
                              </div>
                            </Col>
                          </Row>
                          <hr />
                        </Fragment>
                      ))}
                      <Row className="align-items-center py-3">
                        <Col md={6} xs={8}>
                          <div className="f14-700">
                            Maintain tax and other charges
                          </div>
                        </Col>
                        <Col md={6} xs={4}>
                          <ToggleButtonWithYesNo
                            activeClass={
                              formik.values.dine_in.sur_charges_value
                            }
                            checkedBox={formik.values.dine_in.sur_charges_value}
                            // onChange={() =>
                            //   setDineInSurcharge(!dineInSurcharge)
                            // }
                            onChange={() =>
                              formik.setFieldValue(
                                'dine_in.sur_charges_value',
                                !formik.values.dine_in.sur_charges_value
                              )
                            }
                          />
                        </Col>
                      </Row>
                      {formik.values.dine_in.sur_charges_value ? (
                        <Fragment>
                          {formik.values.dine_in.sur_charges.map(
                            (item, index) => (
                              <TaxesServices
                                noEdit={props.menuCategoryItems?.pos_item_id}
                                changeHandle={(e, name) =>
                                  onChangeValue(e, 'dine_in', index)
                                }
                                removeTax={() => removeTax(item, 'dine_in')}
                                service_name="Dine In"
                                key={index}
                                tax_name={item.name}
                                take_away={item.value}
                                tax_value={item.flag}
                                orderingData={{
                                  take_away: { value: true },
                                }}
                              />
                            )
                          )}

                          {newTaxesDineIn.length > 0 &&
                          !props.menuCategoryItems?.pos_item_id ? (
                            <Fragment>
                              <div
                                className="f14-400 "
                                style={{
                                  color: '#2096F3',
                                  cursor: 'pointer',
                                }}
                                onClick={openAddSurcharges}
                              >
                                Add/Maintain Tax/Surchages
                              </div>
                              <AddSurchargesModel
                                //tax_value={item.tax_value}
                                closeAddSurcharges={closeAddSurcharges}
                                open={addsurcharges}
                                taxInfo={newTaxesDineIn}
                                dine_in_order={showDineIn}
                                onClickSaveModalData={(data) =>
                                  onClickSaveModalDataDineIn(data)
                                }
                              />
                            </Fragment>
                          ) : (
                            <> </>
                          )}
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                </>
              </Fragment>
            ) : (
              <> </>
            )}
            <hr />
            {showCateringBanquet ? (
              <Fragment>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                    <div className="enIconShadow mr-3">
                      <Image
                        src={require('../../../../../../../../assets/images/UserManagement/Icons-03.svg')}
                        alt="add"
                        className="w-20px"
                      />
                    </div>
                    Catering Banquet
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.catering_banquet.value}
                      onChange={() => onChangeCateringBanquet()}
                    />
                  </div>
                </div>
                <>
                  {formik.values.catering_banquet.value ? (
                    <>
                      {showEditCateringBanquet ? (
                        <ServicesEditReuse
                          data={dataForEdit}
                          updatedData={(newData) => updatedEditData(newData)}
                        />
                      ) : (
                        <> </>
                      )}
                      <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                        <div className="f12-700">
                          Set Availability and Price :
                        </div>
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          // onClick={handleShowDetails}
                          onClick={(e) => redirectToStep3(e)}
                        >
                          Missing a Size ? Add
                        </button>
                      </div>
                      {formik.values.catering_banquet.sizes.length !== 0 ? (
                        <Row>
                          <Col md={1} xs={2} className="pb-4 p-0">
                            <div className="f11-700">Available</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-4">
                            <div className="f11-700">Set Default</div>
                          </Col>
                          <Col md={3} xs={2} className="pb-4">
                            <div className="f11-700">Item Name</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-4">
                            <div className="f11-700">Item Price</div>
                          </Col>
                          <Col md={2} xs={3} className="pb-3">
                            <div className="f11-700">Action</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-3">
                            <button
                              type="button"
                              className={
                                'add-button-icon-reusable add-button-icon-reusable-blue'
                              }
                              onClick={() =>
                                handleShowDetails('catering_banquet')
                              }
                            >
                              See more
                            </button>
                          </Col>
                        </Row>
                      ) : (
                        <> </>
                      )}
                      {formik.values.catering_banquet.sizes.map(
                        (item, index) => (
                          <Fragment key={index}>
                            <Row className="align-items-center">
                              <Col md={1} xs={2} className="pb-2">
                                <Form.Check
                                  label="1"
                                  inline
                                  className="enCheckBoxOnly d-grid"
                                  checked={item.available}
                                  onChange={(e) =>
                                    onChangeAvaiblity(
                                      item.available,
                                      index,
                                      'catering_banquet'
                                    )
                                  }
                                />
                              </Col>
                              <Col md={2} xs={2} className="pb-2">
                                <label className="enRadioWithText small d-grid">
                                  <input
                                    type="radio"
                                    name="setDefaultCateringBanquetFinal"
                                    checked={item.isDefault}
                                    onChange={(e) =>
                                      onChangeDefault(index, 'catering_banquet')
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                              </Col>
                              <Col md={3} xs={2} className="pb-2">
                                <div className="f11-400">
                                  {item.description}
                                </div>
                              </Col>
                              <Col md={2} xs={1} className="pb-2">
                                <div className="f11-400">{item.price}</div>
                              </Col>
                              <Col md={4} xs={3} className="pb-2">
                                <div className="d-flex align-itmes-center">
                                  {!props.menuCategoryItems?.pos_item_id && (
                                    <IconButton className="mr-2 p-0">
                                      <Image
                                        src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                        alt="edit item"
                                        title="edit item"
                                        className="w-20px"
                                        onClick={(e) =>
                                          onClickEditItem(
                                            e,
                                            index,
                                            'catering_banquet',
                                            item
                                          )
                                        }
                                      />
                                    </IconButton>
                                  )}
                                  <IconButton className="p-0">
                                    <Image
                                      src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                      alt="delete item"
                                      title="delete item"
                                      className="w-20px"
                                      onClick={(e) =>
                                        onClickDeleteItem(
                                          e,
                                          index,
                                          'catering_banquet'
                                        )
                                      }
                                    />
                                  </IconButton>
                                </div>
                              </Col>
                            </Row>
                            <hr />
                          </Fragment>
                        )
                      )}
                      <Row className="align-items-center py-3">
                        <Col md={6} xs={8}>
                          <div className="f14-700">
                            Maintain tax and other charges
                          </div>
                        </Col>
                        <Col md={6} xs={4}>
                          <ToggleButtonWithYesNo
                            activeClass={
                              formik.values.catering_banquet.sur_charges_value
                            }
                            checkedBox={
                              formik.values.catering_banquet.sur_charges_value
                            }
                            // onChange={() =>
                            //   setCateringBanquetSurcharge(!CateringBanquetSurcharge)
                            // }
                            onChange={() =>
                              formik.setFieldValue(
                                'catering_banquet.sur_charges_value',
                                !formik.values.catering_banquet
                                  .sur_charges_value
                              )
                            }
                          />
                        </Col>
                      </Row>
                      {formik.values.catering_banquet.sur_charges_value ? (
                        <Fragment>
                          {formik.values.catering_banquet.sur_charges.map(
                            (item, index) => (
                              <TaxesServices
                                noEdit={props.menuCategoryItems?.pos_item_id}
                                changeHandle={(e, name) =>
                                  onChangeValue(e, 'catering_banquet', index)
                                }
                                removeTax={() =>
                                  removeTax(item, 'catering_banquet')
                                }
                                service_name="Catering Banquet"
                                key={index}
                                tax_name={item.name}
                                take_away={item.value}
                                tax_value={item.flag}
                                orderingData={{
                                  take_away: { value: true },
                                }}
                              />
                            )
                          )}

                          {newTaxesCateringBanquet.length > 0 &&
                          !props.menuCategoryItems?.pos_item_id ? (
                            <Fragment>
                              <div
                                className="f14-400 "
                                style={{
                                  color: '#2096F3',
                                  cursor: 'pointer',
                                }}
                                onClick={openAddSurcharges}
                              >
                                Add/Maintain Tax/Surchages
                              </div>
                              <AddSurchargesModel
                                //tax_value={item.tax_value}
                                closeAddSurcharges={closeAddSurcharges}
                                open={addsurcharges}
                                taxInfo={newTaxesCateringBanquet}
                                catering_banquet={showCateringBanquet}
                                onClickSaveModalData={(data) =>
                                  onClickSaveModalDataCateringBanquet(data)
                                }
                              />
                            </Fragment>
                          ) : (
                            <> </>
                          )}
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                </>
              </Fragment>
            ) : (
              <> </>
            )}
            <hr />
            {showHomeDelivery ? (
              <Fragment>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                    <div className="enIconShadow mr-3">
                      <Image
                        src={require('../../../../../../../../assets/images/UserManagement/Icons-03.svg')}
                        alt="add"
                        className="w-20px"
                      />
                    </div>
                    Home Delivery
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values?.home_delivery?.value}
                      onChange={() => onChangeHomeDelivery()}
                    />
                  </div>
                </div>
                <>
                  {formik.values?.home_delivery?.value ? (
                    <>
                      {showEditHomeDelivery ? (
                        <ServicesEditReuse
                          data={dataForEdit}
                          updatedData={(newData) => updatedEditData(newData)}
                        />
                      ) : (
                        <> </>
                      )}
                      <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                        <div className="f12-700">
                          Set Availability and Price :
                        </div>
                        <button
                          type="button"
                          className={
                            'add-button-icon-reusable add-button-icon-reusable-blue'
                          }
                          // onClick={handleShowDetails}
                          onClick={(e) => redirectToStep3(e)}
                        >
                          Missing a Size ? Add
                        </button>
                      </div>
                      {formik.values?.home_delivery?.sizes?.length !== 0 ? (
                        <Row>
                          <Col md={1} xs={2} className="pb-4 p-0">
                            <div className="f11-700">Available</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-4">
                            <div className="f11-700">Set Default</div>
                          </Col>
                          <Col md={3} xs={2} className="pb-4">
                            <div className="f11-700">Item Name</div>
                          </Col>
                          <Col md={2} xs={1} className="pb-4">
                            <div className="f11-700">Item Price</div>
                          </Col>
                          <Col md={2} xs={3} className="pb-3">
                            <div className="f11-700">Action</div>
                          </Col>
                          <Col md={2} xs={2} className="pb-3">
                            <button
                              type="button"
                              className={
                                'add-button-icon-reusable add-button-icon-reusable-blue'
                              }
                              onClick={() => handleShowDetails('home_delivery')}
                            >
                              See more
                            </button>
                          </Col>
                        </Row>
                      ) : (
                        <> </>
                      )}
                      {formik.values?.home_delivery?.sizes.map(
                        (item, index) => (
                          <Fragment key={index}>
                            <Row className="align-items-center">
                              <Col md={1} xs={2} className="pb-2">
                                <Form.Check
                                  label="1"
                                  inline
                                  className="enCheckBoxOnly d-grid"
                                  checked={item?.available}
                                  onChange={(e) =>
                                    onChangeAvaiblity(
                                      item?.available,
                                      index,
                                      'home_delivery'
                                    )
                                  }
                                />
                              </Col>
                              <Col md={2} xs={2} className="pb-2">
                                <label className="enRadioWithText small d-grid">
                                  <input
                                    type="radio"
                                    name="setDefaultHomeDeliveryFinal"
                                    checked={item?.isDefault}
                                    onChange={(e) =>
                                      onChangeDefault(index, 'home_delivery')
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                              </Col>
                              <Col md={3} xs={2} className="pb-2">
                                <div className="f11-400">
                                  {item?.description}
                                </div>
                              </Col>
                              <Col md={2} xs={1} className="pb-2">
                                <div className="f11-400">{item?.price}</div>
                              </Col>
                              <Col md={4} xs={3} className="pb-2">
                                <div className="d-flex align-itmes-center">
                                  {!props.menuCategoryItems?.pos_item_id && (
                                    <IconButton className="mr-2 p-0">
                                      <Image
                                        src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                        alt="edit item"
                                        title="edit item"
                                        className="w-20px"
                                        onClick={(e) =>
                                          onClickEditItem(
                                            e,
                                            index,
                                            'home_delivery',
                                            item
                                          )
                                        }
                                      />
                                    </IconButton>
                                  )}
                                  <IconButton className="p-0">
                                    <Image
                                      src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                      alt="delete item"
                                      title="delete item"
                                      className="w-20px"
                                      onClick={(e) =>
                                        onClickDeleteItem(
                                          e,
                                          index,
                                          'home_delivery'
                                        )
                                      }
                                    />
                                  </IconButton>
                                </div>
                              </Col>
                            </Row>
                            <hr />
                          </Fragment>
                        )
                      )}
                      <Row className="align-items-center py-3">
                        <Col md={6} xs={8}>
                          <div className="f14-700">
                            Maintain tax and other charges
                          </div>
                        </Col>
                        <Col md={6} xs={4}>
                          <ToggleButtonWithYesNo
                            activeClass={
                              formik.values?.home_delivery?.sur_charges_value
                            }
                            checkedBox={
                              formik.values?.home_delivery?.sur_charges_value
                            }
                            // onChange={() =>
                            //   setHomeDeliverySurcharge(!HomeDeliverySurcharge)
                            // }
                            onChange={() =>
                              formik.setFieldValue(
                                'home_delivery.sur_charges_value',
                                !formik.values?.home_delivery?.sur_charges_value
                              )
                            }
                          />
                        </Col>
                      </Row>
                      {formik.values?.home_delivery?.sur_charges_value ? (
                        <Fragment>
                          {formik.values?.home_delivery?.sur_charges.map(
                            (item, index) => (
                              <TaxesServices
                                noEdit={props.menuCategoryItems?.pos_item_id}
                                changeHandle={(e, name) =>
                                  onChangeValue(e, 'home_delivery', index)
                                }
                                removeTax={() =>
                                  removeTax(item, 'home_delivery')
                                }
                                service_name="Home Delivery"
                                key={index}
                                tax_name={item?.name}
                                take_away={item?.value}
                                tax_value={item?.flag}
                                orderingData={{
                                  take_away: { value: true },
                                }}
                              />
                            )
                          )}

                          {newTaxesHomeDelivery.length > 0 &&
                          !props.menuCategoryItems?.pos_item_id ? (
                            <Fragment>
                              <div
                                className="f14-400 "
                                style={{
                                  color: '#2096F3',
                                  cursor: 'pointer',
                                }}
                                onClick={openAddSurcharges}
                              >
                                Add/Maintain Tax/Surchages
                              </div>
                              <AddSurchargesModel
                                //tax_value={item.tax_value}
                                closeAddSurcharges={closeAddSurcharges}
                                open={addsurcharges}
                                taxInfo={newTaxesHomeDelivery}
                                home_delivery={showHomeDelivery}
                                onClickSaveModalData={(data) =>
                                  onClickSaveModalDataHomeDelivery(data)
                                }
                              />
                            </Fragment>
                          ) : (
                            <> </>
                          )}
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                </>
              </Fragment>
            ) : (
              <> </>
            )}

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStep7BackButton()}
              />
              <ReusableOnboardingButton
                buttonTitle="Save and Finish"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Finish"
                buttonType="button"
                // onClick={onSubmit}
                onClick={(e) => OnClickNextStep(e)}
              />
            </div>
          </React.Fragment>
        )}
      </Form>
      <Modal show={showDetails} onHide={handleCloseDetails} centered size="xl">
        <Modal.Header className="px-4 border-0" closeButton>
          <Modal.Title className="f20-700">Saved Size Description</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="enGrayBorderBox mb-3">
            <div className="table-responsive">
              <table className="enMinWidth900 w-100 table m-0">
                <tr>
                  <td>
                    <div className="f11-400  pb-2 p-0">Available</div>
                  </td>
                  <td>
                    <div className="f11-400  pb-2">Set Default</div>
                  </td>
                  <td>
                    <div className="f11-400  pb-2">Item Name</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Item Price</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Serving PAX</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Units</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Measure</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Action</div>
                  </td>
                </tr>
                {activeData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Check
                        label="1"
                        inline
                        className="enCheckBoxOnly d-grid"
                        checked={item.available}
                        onChange={(e) =>
                          onChangeAvaiblity(item.available, index, activeName)
                        }
                      />
                    </td>
                    <td>
                      <label className="enRadioWithText small d-grid">
                        <input
                          type="radio"
                          name="setDefault"
                          checked={item.isDefault}
                          onChange={(e) => onChangeDefault(index, activeName)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>
                      <div className="f12-700">{item.description}</div>
                    </td>
                    <td>
                      <div className="f12-700">{item.price}</div>
                    </td>
                    <td>
                      <div className="f12-700">{item.pax}</div>
                    </td>
                    <td>
                      <div className="f12-700">{item.size}</div>
                    </td>
                    <td>
                      <div className="f12-700">{item.uom}</div>
                    </td>
                    <td>
                      <div className="d-flex align-itmes-center mt-2">
                        {!props.menuCategoryItems?.pos_item_id && (
                          <IconButton className="mr-2 p-0">
                            <Image
                              src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                              alt="edit item"
                              title="edit item"
                              className="w-20px"
                              //onClick={(e) => onEditItem(index, item)}
                            />
                          </IconButton>
                        )}
                        <IconButton className="p-0">
                          <Image
                            src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                            alt="delete item"
                            title="delete item"
                            className="w-20px"
                            // onClick={(e) => onClickDeleteIcon(e, index)}
                            onClick={(e) =>
                              onClickDeleteItem(e, index, activeName)
                            }
                          />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete this surcharge ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseDeleteModal}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) => handleDeleteModal(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={deleteItem} onHide={closeDeleteItem} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete this item ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={closeDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) => handleDeleteItem(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

Services.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
  ActiveMenu: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  servicesEnabled:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  menuCategory: state.onboarding && state.onboarding.menuCategory,
  activeItemId: state.onboarding && state.onboarding.activeItemId,
  servicesEnabledFastFood:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering,
  servicesEnabledMultiService:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details
      .multi_service_business_status &&
    state.onboarding.onboard_subscription_details.multi_service_business_status
      .ordering,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining
      ? state.onboarding &&
        state.onboarding.onboard_subscription_details &&
        state.onboarding.onboard_subscription_details.fast_food_dining_status &&
        state.onboarding.onboard_subscription_details.fast_food_dining_status
          .ordering &&
        state.onboarding.onboard_subscription_details.fast_food_dining_status
          .ordering.order_general
      : state.onboarding &&
        state.onboarding.onboard_subscription_details &&
        state.onboarding.onboard_subscription_details.multi_service_business
      ? state.onboarding &&
        state.onboarding.onboard_subscription_details &&
        state.onboarding.onboard_subscription_details
          .multi_service_business_status &&
        state.onboarding.onboard_subscription_details
          .multi_service_business_status.ordering &&
        state.onboarding.onboard_subscription_details
          .multi_service_business_status.ordering.order_general
      : state.onboarding &&
        state.onboarding.onboard_subscription_details &&
        state.onboarding.onboard_subscription_details.casual_dining_status &&
        state.onboarding.onboard_subscription_details.casual_dining_status
          .ordering &&
        state.onboarding.onboard_subscription_details.casual_dining_status
          .ordering.order_general,
  serviceType:
    state.onboarding && state.onboarding.onboard_subscription_details,
  ActiveMenu: state?.onboarding?.active_menu,
});

export default connect(mapStateToProps, {
  update_item_menu_setup,
  get_category_menu_setup_without_loader,
})(Services);
